
import * as React from 'react';
import {ElementRef, RefObject} from 'react';
import {getReactButton, getReactCheckbox, getReactLink, ReactInput} from '../../index';

export enum HeaderSortDirection {
    asc = 0,
    desc = 1,
    noSort = 2, // Column can be sorted, but its not currently being sorted
    undefined = 3 // Column cannot be sorted
}

export interface TableCellData {
    id: string;
    css?: string;
    style?: {};
    displayValue?: any;
    title?: string;
}

const TableCell = (props: TableCellData) => {
    return <td className={props.css} id={props.id} style={(null != props.style) ? props.style : {}} title={props.title} >{props.displayValue}</td>;
};

class ReactCell extends React.Component<TableCellData> {
    constructor(props: TableCellData) {
        super(props);
    }

    getCell() {
        if (this.props.title) {
            return <TableCell css={this.props.css} id={this.props.id} style={(null != this.props.style) ? this.props.style : {}} title={this.props.title} displayValue={this.props.displayValue} />;
        } else {
            return <TableCell css={this.props.css} id={this.props.id} style={(null != this.props.style) ? this.props.style : {}} displayValue={this.props.displayValue} />;
        }
    }

    render() {
        return this.getCell();
    }
}

// Used to place search as you type pop-up tables over everything else
function getHighestZIndex(nBaseElement?: HTMLElement | ElementRef<any>) {
    let iHighest = 0;
    if (null != nBaseElement) {
        iHighest = Math.max.apply(null, $.map($(nBaseElement).filter(':visible'), (e: any) => {
            if ($(e).css('position') != 'static') {
                return parseInt($(e).css('z-index')) || 1;
            } else {
                return -1;
            }
        }));
    } else {
        iHighest = Math.max.apply(null, $.map($('body *:visible'), (e: any) => {
            if ($(e).css('position') != 'static') {
                return parseInt($(e).css('z-index')) || 1;
            } else {
                return -1;
            }
        }));
    }

    return iHighest < 0 ? 0 : iHighest;
}

function getSortIcon(sortDirection: number) {
    if (sortDirection != HeaderSortDirection.undefined) {
        if (sortDirection == HeaderSortDirection.asc) {
            return 'css_right ui-icon ui-icon-triangle-1-n';
        } else if (sortDirection == HeaderSortDirection.desc) {
            return 'css_right ui-icon ui-icon-triangle-1-s';
        } else {
            return 'css_right ui-icon ui-icon-caret-2-n-s';
        }
    }
    return '';
}

function getEnableHeaderDragAndDrop(header: any) {
    let enableHeaderDragAndDrop = false;
    if (null != header.enableHeaderDragAndDrop) {
        enableHeaderDragAndDrop = (typeof(header.enableHeaderDragAndDrop) === 'function') ? header.enableHeaderDragAndDrop() : header.enableHeaderDragAndDrop;
    }
    return enableHeaderDragAndDrop;
}

interface TableHeaderCellData {
    header: any;
    headerIndex: number;
    headerCellRef?: RefObject<any>;
    sortDirection: HeaderSortDirection;
    sortOrder: number;
    displaySortOrderCounts: boolean;
    displayKey: string;
    onClick: (event: React.MouseEvent<HTMLTableHeaderCellElement>) => void;
    startDragHeader: any;
    stopDragHeader: any;
    duringDragHeader: any;
    onDragOver: any;
}

const TableHeaderCell = (props: TableHeaderCellData) => {
    const headerTHID = (null != props.header.thID) ? props.header.thID : props.headerIndex;
    const headerTextID = (null != props.header.id) ? props.header.id : '';
    let headerCSS = 'reactTableHeaderCell colHdr ui-state-default';
    if (null != props.header.css) {
        headerCSS = (typeof props.header.css === 'function') ? props.header.css() : props.header.css;
    }

    let headerCellStyle = {width: '100%', minWidth: '100%', verticalAlign: 'middle'};
    if (null != props.header.style) {
        headerCellStyle = (typeof props.header.style === 'function') ? props.header.style() : props.header.style;
    }

    const headerText = (null != props.header[props.displayKey]) ? props.header[props.displayKey] : '';
    const displayValueCSS = (null != props.header.displayValueCSS) ? props.header.displayValueCSS : 'datatable-header-col';
    const displayValueStyle = (null != props.header.displayValueStyle) ? props.header.displayValueStyle : {verticalAlign: 'middle'};
    const headerTitle = (null != props.header.headerTitle) ? props.header.headerTitle : null;
    const sortShellCSS = (null != props.header.sortShellCSS) ? props.header.sortShellCSS : 'datatable-sorting-col flex-container-inline';
    const sortShellStyle = (null != props.header.sortShellStyle) ? props.header.sortShellStyle : {align: 'right', float: 'right'};

    const enableHeaderDragAndDrop = getEnableHeaderDragAndDrop(props.header);

    function getHeaderText() {
        if (null != props.header.headerCustomObj) {
            if (headerTitle) {
                return <td title={headerTitle} align={props.header.align} id={headerTextID} className={displayValueCSS} style={displayValueStyle}>{headerText}{(null != props.displaySortOrderCounts && props.displaySortOrderCounts && null != props.sortOrder && props.sortOrder > 0) ? <sup>{props.sortOrder}</sup> : null}
                    {props.header.headerCustomObj()}
                </td>;
            } else {
                return <td align={props.header.align} id={headerTextID} className={displayValueCSS} style={displayValueStyle}>{headerText}{(null != props.displaySortOrderCounts && props.displaySortOrderCounts && null != props.sortOrder && props.sortOrder > 0) ? <sup>{props.sortOrder}</sup> : null}
                    {props.header.headerCustomObj()}
                </td>;
            }
        } else {
            if (headerTitle) {
                return <td title={headerTitle} align={props.header.align} id={headerTextID} className={displayValueCSS} style={displayValueStyle}>{headerText}{(null != props.displaySortOrderCounts && props.displaySortOrderCounts && null != props.sortOrder && props.sortOrder > 0) ? <sup>{props.sortOrder}</sup> : null}</td>;
            } else {
                return <td align={props.header.align} id={headerTextID} className={displayValueCSS} style={displayValueStyle}>{headerText}{(null != props.displaySortOrderCounts && props.displaySortOrderCounts && null != props.sortOrder && props.sortOrder > 0) ? <sup>{props.sortOrder}</sup> : null}</td>;
            }
        }
    }

    function getHeaderPost() {
        let postDisplayValueCSS = '';
        if (null != props.header.postDisplayValueCSS) {
            postDisplayValueCSS = (typeof props.header.postDisplayValueCSS === 'function') ? props.header.postDisplayValueCSS() : props.header.postDisplayValueCSS;
        }

        let postDisplayValueStyle = {verticalAlign: 'right'};
        if (null != props.header.postDisplayValueStyle) {
            postDisplayValueStyle = (typeof props.header.postDisplayValueStyle === 'function') ? props.header.postDisplayValueStyle() : props.header.postDisplayValueStyle;
        }

        let postDisplayValueDIVCSS = 'flex-container-inline';
        if (null != props.header.postDisplayValueDIVCSS) {
            postDisplayValueDIVCSS = (typeof props.header.postDisplayValueDIVCSS === 'function') ? props.header.postDisplayValueDIVCSS() : props.header.postDisplayValueDIVCSS;
        }

        let postDisplayValueDIVStyle = {};
        if (null != props.header.postDisplayValueDIVStyle) {
            postDisplayValueDIVStyle = (typeof props.header.postDisplayValueDIVStyle === 'function') ? props.header.postDisplayValueDIVStyle() : props.header.postDisplayValueDIVStyle;
        }

        if (null != props.header.headerPostCustomObj) {
            const thisCustomObj = props.header.headerPostCustomObj();
            if (null !== thisCustomObj) {
                return <td className={postDisplayValueCSS} style={postDisplayValueStyle}>
                        <div className={postDisplayValueDIVCSS} style={postDisplayValueDIVStyle}>
                            {thisCustomObj}
                            {(enableHeaderDragAndDrop) ? <div className="fas fa-bars fa-2x ui-sortable movable manualSort" style={{float: 'right'}}></div> : null}
                        </div>
                    </td>;
            }
        }
        return (enableHeaderDragAndDrop) ?
            <td className={postDisplayValueCSS} style={postDisplayValueStyle}>
                <div className="fas fa-bars fa-2x ui-sortable movable manualSort"></div>
            </td>
            : null;
    }

    return <th ref={props.headerCellRef} id={headerTHID} onClick={props.onClick} className={headerCSS} align="left" style={headerCellStyle} draggable={enableHeaderDragAndDrop} onDragStart={props.startDragHeader} onDragEnd={props.stopDragHeader} onDragEnter={props.duringDragHeader} onDragOver={props.onDragOver}>
        <table width="100%">
                <tr>
                    {getHeaderText()}
                    <td className={sortShellCSS} style={sortShellStyle}>
                        <div className="DataTables_sort_wrapper">
                            <span className={getSortIcon(props.sortDirection) }></span>
                        </div>
                        {getHeaderPost()}
                    </td>
                </tr>
            </table>
        </th>;
};

interface ReactHeaderCellData {
    index: number;
    header: any;
    displaySortOrderCounts?: boolean;
    headerClick: (event: React.MouseEvent<HTMLTableHeaderCellElement>, index: number, shiftKeyPressed: boolean) => void;
    displayKey: string;
    title?: string;
    onDuringDragHeader?: (event: any, header: any, headerCellRef: RefObject<any>) => void;
    onDragHeaderStart?: (event: any, header: any) => void;
    onDragHeaderStop?: (event: any, header: any) => void;
}
interface ReactHeaderCellState {
    sortDirection: HeaderSortDirection;
    sortOrder: number;
}

export class ReactHeaderCell extends React.Component<ReactHeaderCellData> {
    headerCellRef: RefObject<any>;

    constructor(props: ReactHeaderCellData) {
        super(props);
        this.state = {sortDirection: props.header.sortDirection, sortOrder: props.header.sortOrder};
        this.headerCellRef = React.createRef();

        // Binding is necessary to allow these functions access to the State data
        this.sortColumn = this.sortColumn.bind(this);
        this.startDragHeader = this.startDragHeader.bind(this);
        this.stopDragHeader = this.stopDragHeader.bind(this);
        this.onDragOverHeader = this.onDragOverHeader.bind(this);
        this.onDuringDragHeader = this.onDuringDragHeader.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactHeaderCellData) {
        this.setState({
            sortDirection: props.header.sortDirection,
            sortOrder: props.header.sortOrder,
        });
    }

    startDragHeader(event: any) {
        if (getEnableHeaderDragAndDrop(this.props.header)) {
            this.props.onDragHeaderStart(event, this.props.header);
            event.dataTransfer.effectAllowed = 'move';
        }
    }

    stopDragHeader(event: React.DragEvent<HTMLTableRowElement>) {
        if (getEnableHeaderDragAndDrop(this.props.header)) {
            this.props.onDragHeaderStop(event, this.props.header);
        }
    }

    onDragOverHeader(event: any) {
        event.preventDefault();
    }

    onDuringDragHeader(event: React.DragEvent<HTMLTableRowElement>) {
        if (getEnableHeaderDragAndDrop(this.props.header)) {
            if (null != this.props.onDuringDragHeader) {
                this.props.onDuringDragHeader(event, this.props.header, this.headerCellRef);
            }
        }
        event.preventDefault();
    }

    sortColumn(event: React.MouseEvent<HTMLTableHeaderCellElement>) {
            if (null != (this.props as ReactHeaderCellData).headerClick) {
                (this.props as ReactHeaderCellData).headerClick(event, (this.props as ReactHeaderCellData).index, event.shiftKey);
        }
    }

    render() {
        return <TableHeaderCell displayKey={(this.props as ReactHeaderCellData).displayKey} onClick={this.sortColumn} header={(this.props as ReactHeaderCellData).header} headerCellRef={this.headerCellRef} sortDirection={(this.state as ReactHeaderCellState).sortDirection} sortOrder={(this.state as ReactHeaderCellState).sortOrder} displaySortOrderCounts={this.props.displaySortOrderCounts} headerIndex={(this.props as ReactHeaderCellData).index} startDragHeader={this.startDragHeader} stopDragHeader={this.stopDragHeader} duringDragHeader={this.onDuringDragHeader} onDragOver={this.onDragOverHeader} />;
    }
}

interface ReactHeaderData {
    id?: string;
    css?: string;
    headers?: TableHeaderCellData[];
    addSelectColumn?: boolean;
    selectColumnIndex?: number; // -1 to add to the end
    sortTable?: (headers: any, onLoad: boolean) => void;
    selectHeaderClick?: (event: React.MouseEvent<HTMLTableHeaderCellElement>, index: number, shiftKeyPressed: boolean) => void;
    enableDragAndDrop?: boolean;
    sortColumnIndex?: number; // -1 to add to the end
    addDeleteColumn?: boolean;
    deleteColumnIndex?: number; // -1 to add to the end
    headerRef?: RefObject<any>;
    displayKey?: string;
    title?: string;
    overrideSortID?: string;
    overrideSortName?: string;
    onDuringDragHeader?: (event: any, header: any, headerCellRef: RefObject<any>) => void;
    onDragHeaderStart?: (event: any, header: any) => void;
    onDragHeaderStop?: (event: any, header: any) => void;
    deleteColumnHeader?: string;
}

class ReactHeader extends React.Component<ReactHeaderData> {
    overrideSortHeaderRef: RefObject<any>;

    constructor(props: ReactHeaderData) {
        super(props);

        this.overrideSortHeaderRef = React.createRef();

        // Binding is necessary to allow these functions access to the State data
        this.headerClick = this.headerClick.bind(this);
        this.updateHeaderClick = this.updateHeaderClick.bind(this);
        this.startResizing = this.startResizing.bind(this);

        this.state = {
            headers: props.headers
        };
    }

    getNewSortOrder(prevSortDirection: HeaderSortDirection, shiftKeyPressed: boolean) {
        if (prevSortDirection != HeaderSortDirection.undefined) {
            if (shiftKeyPressed) {
                if (prevSortDirection == HeaderSortDirection.asc) {
                    return HeaderSortDirection.desc;
                } else if (prevSortDirection == HeaderSortDirection.noSort) {
                    return HeaderSortDirection.asc;
                } else {
                    return HeaderSortDirection.noSort;
                }
            } else {
                if (prevSortDirection == HeaderSortDirection.desc || prevSortDirection == HeaderSortDirection.noSort) {
                    return HeaderSortDirection.asc;
                } else {
                    return HeaderSortDirection.desc;
                }
            }
        }
        return HeaderSortDirection.undefined;
    }

    headerClick(event: any, headerIndex: number, shiftKeyPressed: boolean) {
        if (
            headerIndex >= 0 &&
            headerIndex < this.props.headers.length &&
            null != this.props.headers[headerIndex].sortDirection &&
            this.props.headers[headerIndex].sortDirection != HeaderSortDirection.undefined
        ) {
            this.setState((prevState: ReactHeaderData) => {
                const newHeaders = prevState.headers;

                // If the Shift Key was pressed, compound the sort
                if (shiftKeyPressed) {
                    // Get a list of sort orders being used
                    let sortOrderList: number[] = [];
                    for (let i = 0; i < newHeaders.length; i++) {
                        if (null != newHeaders[i].sortOrder && newHeaders[i].sortOrder > 0) {
                            sortOrderList.push(newHeaders[i].sortOrder);
                        }
                    }

                    // Sort the list of sort orders, so we can figure out the new sort orders for each header
                    sortOrderList = sortOrderList.sort((order1, order2) => order1 > order2 ? 1 : -1);

                    // Loop over the headers and set the sort orders
                    for (let index = 0; index < newHeaders.length; index++) {
                        const header = newHeaders[index];
                        if (header.sortDirection != HeaderSortDirection.undefined) {
                            if (index == headerIndex) {
                                header.sortDirection = this.getNewSortOrder(header.sortDirection, true);
                                if (header.sortDirection == HeaderSortDirection.noSort) {
                                    const sortOrderIndex = sortOrderList.indexOf(header.sortOrder);
                                    if (sortOrderIndex > -1) {
                                        sortOrderList.splice(sortOrderIndex, 1);
                                    }
                                    header.sortOrder = -1;
                                } else if (header.sortOrder > 0) {
                                    header.sortOrder = sortOrderList.indexOf(header.sortOrder) + 1;
                                } else {
                                    header.sortOrder = sortOrderList.length + 1;
                                }
                            } else {
                                if (header.sortDirection == HeaderSortDirection.noSort) {
                                    const sortOrderIndex = sortOrderList.indexOf(header.sortOrder);
                                    if (sortOrderIndex > -1) {
                                        sortOrderList.splice(sortOrderIndex, 1);
                                    }
                                    header.sortOrder = -1;
                                } else {
                                    header.sortOrder = sortOrderList.indexOf(header.sortOrder) + 1;
                                }
                            }
                        } else {
                            const sortOrderIndex = sortOrderList.indexOf(header.sortOrder);
                            if (sortOrderIndex > -1) {
                                sortOrderList.splice(sortOrderIndex, 1);
                            }
                            header.sortOrder = -1;
                        }
                    }
                } else {
                    // Single header click, sort only the selected header
                    newHeaders.map((header: TableHeaderCellData, index) => {
                        if (header.sortDirection != HeaderSortDirection.undefined) {
                            if (index == headerIndex) {
                                header.sortDirection = this.getNewSortOrder(header.sortDirection, false);
                                header.sortOrder = 1;
                            } else {
                                header.sortDirection = HeaderSortDirection.noSort;
                                header.sortOrder = -1; // Clear the sort orders for all other headers
                            }
                        }
                    });
                }
                return {headers: newHeaders};
            }, () => {
                if (null != (this.props as ReactHeaderData).sortTable) {
                    (this.props as ReactHeaderData).sortTable((this.state as ReactHeaderData).headers, false);
                }
            });
        }
    }

    updateHeaderClick() {
        if (null != this.overrideSortHeaderRef && undefined != this.overrideSortHeaderRef && null != this.overrideSortHeaderRef.current) {
            const newVal = $(this.overrideSortHeaderRef.current).val();
            const newHeaders: TableHeaderCellData[] = JSON.parse(newVal.toString());
            this.setState((prevState: ReactHeaderData) => {
                const updateHeader = prevState.headers;

                if (newHeaders.length === updateHeader.length) {
                    for (let i = 0; i < updateHeader.length; i++) {
                        updateHeader[i].sortOrder = newHeaders[i].sortOrder;
                        updateHeader[i].sortDirection = newHeaders[i].sortDirection;
                    }
                }

                return {headers: updateHeader};
            }, () => {
                if (null != (this.props as ReactHeaderData).sortTable) {
                    (this.props as ReactHeaderData).sortTable((this.state as ReactHeaderData).headers, false);
                }
            });
        }
    }

    getSelectHeader() {
        return <ReactHeaderCell index={-1} header={{
            id: 'reactSelectColumn',
            style: {width: '10px', verticalAlign: 'middle'},
            align: 'center',
            displayValue: getReactLink({
                    id: this.props.id + '_reactSelectHeader',
                    href: '#',
                    text: 'Select',
                    style: {color: 'darkblue', textDecoration: 'none'},
                    row: null,
                    onClick: null
                }),
            sortDirection: HeaderSortDirection.undefined,
            title: this.props.title,
        }}
            headerClick={(this.props as ReactHeaderData).selectHeaderClick}
            displayKey={'displayValue'}
            onDuringDragHeader={(this.props as ReactHeaderData).onDuringDragHeader}
            onDragHeaderStart={(this.props as ReactHeaderData).onDragHeaderStart}
            onDragHeaderStop={(this.props as ReactHeaderData).onDragHeaderStop}
        >
        </ReactHeaderCell>;
    }

    getSortHeader() {
        return <ReactHeaderCell index={-1} header={{
            id: 'reactSortColumn',
            style: {width: '10px', verticalAlign: 'middle'},
            align: 'left',
            displayValue: 'Sort',
            sortDirection: HeaderSortDirection.undefined
        }} headerClick={
            (this.props as ReactHeaderData).selectHeaderClick}
            displayKey={'displayValue'}
            onDuringDragHeader={(this.props as ReactHeaderData).onDuringDragHeader}
            onDragHeaderStart={(this.props as ReactHeaderData).onDragHeaderStart}
            onDragHeaderStop={(this.props as ReactHeaderData).onDragHeaderStop}
        ></ReactHeaderCell>;
    }

    getBlankHeader() {
        return <ReactHeaderCell index={-1} header={{
            id: 'reactDeleteColumn',
            style: {width: '20px', verticalAlign: 'middle'},
            align: 'left',
            displayValue: '',
            sortDirection: HeaderSortDirection.undefined
        }} headerClick={
            (this.props as ReactHeaderData).selectHeaderClick}
            displayKey={'displayValue'}
            onDuringDragHeader={(this.props as ReactHeaderData).onDuringDragHeader}
            onDragHeaderStart={(this.props as ReactHeaderData).onDragHeaderStart}
            onDragHeaderStop={(this.props as ReactHeaderData).onDragHeaderStop}
        ></ReactHeaderCell>;
    }

    getDeleteHeader() {
        return <ReactHeaderCell index={-1} header={{
            id: 'reactDeleteColumn',
            style: {width: '10px', verticalAlign: 'middle'},
            align: 'left',
            sortDirection: HeaderSortDirection.undefined,
            displayValue: this.props.deleteColumnHeader,
        }} headerClick={
            (this.props as ReactHeaderData).selectHeaderClick}
                                displayKey={'displayValue'}
                                onDuringDragHeader={(this.props as ReactHeaderData).onDuringDragHeader}
                                onDragHeaderStart={(this.props as ReactHeaderData).onDragHeaderStart}
                                onDragHeaderStop={(this.props as ReactHeaderData).onDragHeaderStop}
        ></ReactHeaderCell>;
    }

    getDisplaySortOrderCounts() {
        let count = 0;
        this.props.headers.map((header) => {
            if (null != header.sortOrder && header.sortOrder > 0) {
                count = count + 1;
            }
        });
        return count > 1;
    }

    startResizing(event: React.MouseEvent<HTMLDivElement, MouseEvent>, headerIndex: number, dividerResizeColumnWidthInPercentages: boolean) {
        event.preventDefault(); // Prevent default text selection behavior
        document.body.style.userSelect = 'none'; // Disable text selection

        const dividerColumn = $(event.currentTarget);
        const jQueryColumn = $(dividerColumn);
        if (!dividerColumn) {
            return;
        }

        const startX = event.pageX;
        const leftCol = jQueryColumn.prev();
        const rightCol = jQueryColumn.next();
        const startWidthLeft = leftCol.width();
        const startWidthRight = rightCol.width();

        const mouseMoveEvent = 'mousemove.' + this.props.id;
        const mouseUpEvent = 'mouseup.' + this.props.id;

        $(document.body).on(mouseMoveEvent, (moveEvent) => {
            if (dividerResizeColumnWidthInPercentages) {
                const table = leftCol.closest('table'); // Get the parent table
                const tableWidth = table.width(); // Get the total table width

                const diff = moveEvent.pageX - startX;
                const newLeftWidth = startWidthLeft + diff;
                const newRightWidth = startWidthRight - diff;

                // Convert pixel widths to percentages
                const leftPercent = (newLeftWidth / tableWidth) * 100;
                const rightPercent = (newRightWidth / tableWidth) * 100;

                // Apply the percentage widths
                leftCol.css('width', leftPercent + '%');
                rightCol.css('width', rightPercent + '%');
            } else {
                const diff = moveEvent.pageX - startX;
                leftCol.width(startWidthLeft + diff);
                rightCol.width(startWidthRight - diff);
            }
        });

        $(document.body).on(mouseUpEvent, (upEvent) => {
            $(document.body).off(mouseMoveEvent);
            $(document.body).off(mouseUpEvent);
            document.body.style.userSelect = ''; // Re-enable text selection
        });
    }

    getHeaderDivider(headerIndex: number, header: any) {
        const totalNumberOfHeaders = (this.state as ReactHeaderData).headers.length;
        if (headerIndex >= 0 && headerIndex < (totalNumberOfHeaders - 1)) {
            const dividerID = (null != header.dividerID) ? header.dividerID : 'headerDivider' + (headerIndex + 1);
            const dividerResizeColumnWidthInPercentages = (null != header.dividerResizeColumnWidthInPercentages && header.dividerResizeColumnWidthInPercentages);
            let dividerStyle = {};
            if (null != header.dividerStyle) {
                dividerStyle = header.dividerStyle;
            } else {
                if (dividerResizeColumnWidthInPercentages) {
                    if (header.dividerResizeColumn) {
                        dividerStyle = {width: '0%', padding: '0px', margin: '0px', cursor: 'col-resize'};
                    } else {
                        dividerStyle = {width: '0%', padding: '0px', margin: '0px'};
                    }
                } else {
                    if (header.dividerResizeColumn) {
                        dividerStyle = {width: '0px', padding: '0px', margin: '0px', cursor: 'col-resize'};
                    } else {
                        dividerStyle = {width: '0px', padding: '0px', margin: '0px'};
                    }
                }
            }

            const dividerCSS = (null != header.dividerCSS) ? header.dividerCSS : '';
            if (header.dividerResizeColumn) {
                return <th id={dividerID} className={dividerCSS} style={dividerStyle} onMouseDown={(event) => this.startResizing(event, headerIndex, dividerResizeColumnWidthInPercentages)} ></th>;
            } else {
                return <th id={dividerID} className={dividerCSS} style={dividerStyle}></th>;
            }
        } else {
            return '';
        }
    }

    getAddColumnDivider(header: any) {
        if (null != header.addColumnDivider) {
            if (typeof header.addColumnDivider === 'function') {
                return header.addColumnDivider();
            } else {
                return header.addColumnDivider;
            }
        }
        return false;
    }

    getCanDisplayHeader(header: any) {
        if (null != header.display) {
         if (typeof(header.display) === 'function') {
             return header.display();
         } else {
             return header.display;
         }
        }
        return true;
    }

    buildHeaderCell(header: TableHeaderCellData, headerIndex: number) {
        const addSelectColumnBefore = (this.props as ReactHeaderData).addSelectColumn && (this.props as ReactHeaderData).selectColumnIndex == headerIndex;
        const addDeleteColumnBefore = (this.props as ReactHeaderData).addDeleteColumn && (this.props as ReactHeaderData).deleteColumnIndex == headerIndex;
        const addSortColumnBefore = (this.props as ReactHeaderData).enableDragAndDrop && (this.props as ReactHeaderData).sortColumnIndex == headerIndex;
        const canDisplayHeader = this.getCanDisplayHeader(header);

        return <React.Fragment>
            {((addSelectColumnBefore) ? this.getSelectHeader() : null)}
            {((addDeleteColumnBefore) ? this.getDeleteHeader() : null)}
            {((addSortColumnBefore) ? this.getSortHeader() : null)}
            {(canDisplayHeader) ? <ReactHeaderCell header={header} displaySortOrderCounts={this.getDisplaySortOrderCounts()} index={headerIndex} headerClick={
                this.headerClick}
                displayKey={'displayValue'}
                onDuringDragHeader={(this.props as ReactHeaderData).onDuringDragHeader}
                onDragHeaderStart={(this.props as ReactHeaderData).onDragHeaderStart}
                onDragHeaderStop={(this.props as ReactHeaderData).onDragHeaderStop}
            ></ReactHeaderCell> : ''}
            {(this.getAddColumnDivider((this.state as ReactHeaderData).headers[headerIndex] as any)) ? this.getHeaderDivider(headerIndex, (this.state as ReactHeaderData).headers[headerIndex] as any) : null}
        </React.Fragment>;
    }

    render() {
        return (
            <thead ref={(this.props as ReactHeaderData).headerRef} className={(this.props as ReactHeaderData).css}>
            <input ref={this.overrideSortHeaderRef} className="categoryAllHide" type="text" id={(null != this.props.overrideSortID) ? this.props.overrideSortID : this.props.id + '_overrideSortID'} name={(null != this.props.overrideSortName) ? this.props.overrideSortName : this.props.id + '_overrideSortID'} onClick={this.updateHeaderClick}></input>
            {(this.state as ReactHeaderData).headers.map((header, index) => this.buildHeaderCell(header, index))}
            {(((this.props as ReactHeaderData).addSelectColumn && (this.props as ReactHeaderData).selectColumnIndex == -1) ? this.getSelectHeader() : null)}
            {(((this.props as ReactHeaderData).addDeleteColumn && (this.props as ReactHeaderData).deleteColumnIndex == -1) ? this.getDeleteHeader() : null)}
            {(((this.props as ReactHeaderData).enableDragAndDrop && (this.props as ReactHeaderData).sortColumnIndex == -1) ? this.getSortHeader() : null)}
            </thead>
        );
    }
}

interface ReactRowData {
    row: any;
    headers: any[];
    isSelectedKey: string;
    id: string;
    name: string;
    rowIndex?: number;
    overallIndex?: number;
    rowClass?: string;
    rowStyle?: {};
    doHighlightRow?: boolean;
    rowHasFocus?: boolean;
    disabled?: boolean;
    deleteButtonTabIndex?: null;
    enableDragAndDrop?: boolean;
    sortColumnIndex?: number; // -1 to add to the end
    addSelectColumn?: boolean;
    selectColumnIndex?: number; // -1 to add to the end
    onSelectCellClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, applySelection: boolean, lastSelectedRowIndex: number) => void;
    onRowClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, applySelection: boolean) => void;
    addDeleteColumn?: boolean;
    deleteButtonStyle?: (row: any, rowIndex: number) => {};
    deleteColumnIndex?: number; // -1 to add to the end
    onDelete?: (rowObj: any) => void;
    rowReference?: RefObject<any>;
    onDragStart?: (event: React.DragEvent<HTMLTableRowElement>, row: any) => void;
    onDragStop?: (event: React.DragEvent<HTMLTableRowElement>) => void;
    onDuringDrag?: (event: React.DragEvent<HTMLTableRowElement>, row: any) => void;
    selectColumns?: [];
    onRowDoubleClick?: (rowOBJ: any) => void;
    hightlightSelectedRowCSS?: (row: any, rowIndex: number) => string;
    rowHasFocusCSS?: (row: any, rowIndex: number) => string;
    selectRecordWithRowClick?: boolean;
    selectRecordsWithRowDrag?: boolean;
    useRowDataStorage?: boolean;
    storedData?: any;
    dataKey?: string;
    hiddenSelectedKey?: string;
    hiddenSelectedKeyDelimiter?: string;
    parentTableRef?: RefObject<any>;
    disableDelete?: (row: any, rowIndex: number) => boolean;
    storedDataAsJSONArray?: boolean;
    newJSONData?: (row: any, rowIndex: number, jsonData: any) => {};
    deleteButtonID?: (row: any, rowIndex: number, overallIndex: number) => string;
    deleteButtonName?: (row: any, rowIndex: number, overallIndex: number) => string;
    selectCheckBoxID?: (row: any, rowIndex: number, overallIndex: number) => string;
    selectCheckBoxName?: (row: any, rowIndex: number, overallIndex: number) => string;
    lastIndex?: number;
    searchValue?: string;
    toolBarDisplayTotalCSS?: string;
    toolBarDisplayTotalStyle?: {};
    onSelectionChange?: (totalSelected: number) => void;
}

class ReactRow extends React.Component<ReactRowData> {
    constructor(props: ReactRowData) {
        super(props);

        // Binding is necessary to allow these functions access to the State data
        this.startDragRow = this.startDragRow.bind(this);
        this.stopDragRow = this.stopDragRow.bind(this);
        this.onDragOver = this.onDragOver.bind(this);
        this.duringDragRow = this.duringDragRow.bind(this);
        this.onCheckboxClick = this.onCheckboxClick.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onDblClick = this.onDblClick.bind(this);
    }

    startDragRow(event: React.DragEvent<HTMLTableRowElement>) {
        if (!this.props.disabled && (this.props.enableDragAndDrop || this.props.selectRecordsWithRowDrag)) {
            this.props.onDragStart(event, this.props.row);

            // Prevents the drag row animation, since we are not actually moving the row anywhere
            if (this.props.selectRecordsWithRowDrag) {
              event.dataTransfer.setDragImage(new Image(), 0, 0);
            }
            event.dataTransfer.effectAllowed = 'move';
        }
    }

    stopDragRow(event: React.DragEvent<HTMLTableRowElement>) {
        if (!this.props.disabled && (this.props.enableDragAndDrop || this.props.selectRecordsWithRowDrag)) {
            this.props.onDragStop(event);
        }
    }

    onDragOver(event: any) {
        event.preventDefault();
    }

    duringDragRow(event: React.DragEvent<HTMLTableRowElement>) {
        if (!this.props.disabled && (this.props.enableDragAndDrop || this.props.selectRecordsWithRowDrag)) {
            this.props.onDuringDrag(event, this.props.row);
        }
        event.preventDefault();
    }

    onRowClick(event: any) {
        if (null != this.props.onRowClick) {
            this.props.onRowClick(this.props.row, event.shiftKey, event.ctrlKey, true);
        }
    }

    onDblClick() {
        if (null != this.props.onRowDoubleClick) {
            this.props.onRowDoubleClick(this.props.row);
        }
    }

    onLinkClick(rowOBJ: any, shiftKey: boolean, ctrlKey: boolean) {
        if (this.props.onSelectCellClick && !(this.props.selectRecordWithRowClick)) {
            this.props.onSelectCellClick(rowOBJ, shiftKey, ctrlKey, true, -1);
        }
    }

    onCheckboxClick(rowOBJ: any, shiftKey: boolean, ctrlKey: boolean) {
        if (this.props.onSelectCellClick) {
            this.props.onSelectCellClick(rowOBJ, shiftKey, ctrlKey, (this.props.selectRecordWithRowClick), -1);
        }
    }

    isSelectionCell(cellIndex: number) {
        if (this.props.selectColumns) {
            for (let i = 0; i < this.props.selectColumns.length; i++) {
                if (this.props.selectColumns[i] == cellIndex) {
                    return true;
                }
            }
        }

        return false;
    }

    onDelete(event: React.MouseEvent<HTMLButtonElement, MouseEvent>, disableDeleteBtn: boolean) {
        if (!disableDeleteBtn && null != this.props.onDelete) {
            this.props.onDelete(this.props.row);
        }
        event.stopPropagation();
    }

    getSelectCell() {

        const checkBoxID = (null != this.props.selectCheckBoxID) ? this.props.selectCheckBoxID(this.props.row, this.props.rowIndex, this.props.overallIndex) : this.props.id + '_checkbox';

        let checkBoxName = '';
        if (null != this.props.selectCheckBoxName) {
            checkBoxName = this.props.selectCheckBoxName(this.props.row, this.props.rowIndex, this.props.overallIndex);
        } else {
            checkBoxName = (this.props.name.length > 0) ? this.props.name + '_checkbox' : '';
        }

        const id = this.props.id;
        if (this.props.storedDataAsJSONArray || this.props.useRowDataStorage) {
            return <ReactCell id={this.props.id + '_rc'} css={'align-obj-center'} style={{verticalAlign: 'middle'}} displayValue={getReactCheckbox({
                id: checkBoxID,
                name: checkBoxName,
                css: 'align-obj-center',
                onClick: this.onCheckboxClick,
                disabled: this.props.disabled,
                row: this.props.row,
                useRowDataStorage: this.props.useRowDataStorage,
                storedData: this.props.storedData,
                dataKey: this.props.dataKey,
                hiddenSelectedKey: this.props.hiddenSelectedKey,
                hiddenSelectedKeyDelimiter: this.props.hiddenSelectedKeyDelimiter,
                storedDataAsJSONArray: this.props.storedDataAsJSONArray,
                newJSONData: this.props.newJSONData,
            })} />;
        } else {
            return <ReactCell id={id + '_rc'} css={'align-obj-center'} style={{verticalAlign: 'middle'}} displayValue={getReactCheckbox({
                id: checkBoxID,
                name: checkBoxName,
                css: 'align-obj-center',
                onClick: this.onCheckboxClick,
                disabled: this.props.disabled,
                row: this.props.row,
                dataKey: this.props.isSelectedKey,
            })} />;
        }
    }

    getSortCell() {
        return <ReactCell id={(this.props.id + '_sort')} css={'align-obj-center'} displayValue={<i className={'fas fa-bars fa-2x ui-sortable movable manualSort' + ((this.props.disabled) ? ' ui-button-disabled ui-state-disabled' : '')} ></i>} style={{}}/>;
    }

    getDeleteCell() {
        const buttonID = (null != this.props.deleteButtonID) ? this.props.deleteButtonID(this.props.row, this.props.rowIndex, this.props.overallIndex) : this.props.id + '_deleteButton';
        let buttonName = '';
        if (null != this.props.deleteButtonName) {
            buttonName = this.props.deleteButtonName(this.props.row, this.props.rowIndex, this.props.overallIndex);
        } else {
            buttonName = (this.props.name.length > 0) ? this.props.name + '_deleteButton' : '';
        }

        const disableDeleteBtn = (this.props.disabled) ? true : ((null != this.props.disableDelete) ? this.props.disableDelete(this.props.row, this.props.rowIndex) : false);
        return <ReactCell id={this.props.id + '_delete'} css={'align-obj-center'} displayValue={<button id={buttonID} name={buttonName} tabIndex={this.props.deleteButtonTabIndex} className={'ui-button ui-corner-all ui-widget ui-button-icon-only' + ((disableDeleteBtn) ? ' ui-button-disabled ui-state-disabled' : '')} style={(null != this.props.deleteButtonStyle) ? this.props.deleteButtonStyle(this.props.row, this.props.rowIndex) : {}} onClick={event => this.onDelete(event, disableDeleteBtn)} type="button" disabled={disableDeleteBtn} >
            <span className="ui-button-icon ui-icon ui-icon-circle-close"></span>
            <span className="ui-button-icon-space"> </span>
        </button>} style={{}}/>;
    }

    indexOfStoredDataJSON(data: any, key: string) {
        for (let i = 0; i < data.length; i++) {
            if (data[i][this.props.dataKey] === key) {
                return i;
            }
        }

        return -1;
    }

    getRowDivider(rowCell: any, headerIndex: number, header: any, rowIndex: number) {
        const totalNumberOfHeaders = this.props.headers.length;
        if (headerIndex >= 0 && headerIndex < (totalNumberOfHeaders - 1)) {
            let cellStyle = {verticalAlign: 'middle'};
            let cellCSS = '';
            let dividerDisplayValue = <div style={{width: '3px'}}></div>;
            if (null != header) {
                if (header.dividerCellCSS) {
                    cellCSS = header.dividerCellCSS(rowCell, rowIndex, headerIndex);
                }
                if (header.dividerCellStyle) {
                    cellStyle = header.dividerCellStyle(rowCell, rowIndex, headerIndex);
                }
                if (header.dividerDisplayValue) {
                    dividerDisplayValue = header.dividerDisplayValue(rowCell, rowIndex, headerIndex);
                }
            }

            return <ReactCell id={(this.props.id + '_divider')} css={cellCSS} style={cellStyle} displayValue={dividerDisplayValue}/>;
        } else {
            return '';
        }
    }

    getAddColumnDivider(header: any) {
        if (null != header.addColumnDivider) {
            if (typeof header.addColumnDivider === 'function') {
                return header.addColumnDivider();
            } else {
                return header.addColumnDivider;
            }
        }
        return false;
    }

    getCanDisplayCell(header: any, rowCell: any, rowIndex: number) {
        if (null != header.display) {
            if (typeof(header.display) === 'boolean') {
                return header.display;
            } else {
                return header.display();
            }
        } else if (null != header.displayCell) {
            return header.displayCell(rowCell, rowIndex);
        }
        return true;
    }

    buildCell(rowCell: any, rowIndex: number, header: any, cellIndex: number) {
        const addSelectColumnBefore = this.props.addSelectColumn && this.props.selectColumnIndex == cellIndex;
        const addDeleteColumnBefore = this.props.addDeleteColumn && this.props.deleteColumnIndex == cellIndex;
        const addSortColumnBefore = this.props.enableDragAndDrop && this.props.sortColumnIndex == cellIndex;

        let cellID = (null != rowCell.id) ? rowCell.id + '_' + cellIndex: '';
        let cellCSS = 'align-obj-left';
        let cellStyle = {paddingLeft: '4px', verticalAlign: 'middle'};
        let cellTitle = null;

        let displayKey = '';
        let customObj = null;
        let canDisplayCell = true;
        if (null != header) {
            canDisplayCell = this.getCanDisplayCell(header, rowCell, rowIndex);
            displayKey = (null != header.displayKey) ? header.displayKey : '';
            customObj = (null != header.customObj) ? header.customObj : null;

            if (header.cellID) {
                if(typeof(header.cellID) === "function") {
                    cellID = header.cellID(rowCell, rowIndex);
                } else {
                    cellID = header.cellID;
                }
            }

            if (header.cellCSS) {
                if(typeof(header.cellCSS) === "function") {
                    cellCSS = header.cellCSS(rowCell, rowIndex);
                } else {
                    cellCSS = header.cellCSS;
                }
            }

            // The cell style overrides the header cellStyle
            if (header.cellStyle) {
                if(typeof(header.cellStyle) === "function") {
                    cellStyle = header.cellStyle(rowCell, rowIndex);
                } else {
                    cellStyle = header.cellStyle;
                }
            }

            if (header.cellTitle) {
                if(typeof(header.cellTitle) === "function") {
                    cellTitle = header.cellTitle(rowCell, rowIndex);
                } else {
                    cellTitle = header.cellTitle;
                }
            }
        }

        let displayVal: (JSX.Element | ReactInput | string) = '';
        if (null != customObj) {
            if (this.props.storedDataAsJSONArray) {
                const storageIndex = this.indexOfStoredDataJSON(this.props.storedData, this.props.row[this.props.hiddenSelectedKey]);
                if (storageIndex > -1) {
                    displayVal = customObj(this.props.row, this.props.disabled, this.props.rowIndex, this.props.storedData[storageIndex], this.props.overallIndex, this.props.lastIndex, this.props.doHighlightRow, this.props.searchValue);
                }
            } else {
                displayVal = customObj(this.props.row, this.props.disabled, this.props.rowIndex, this.props.storedData, this.props.overallIndex, this.props.lastIndex, this.props.doHighlightRow, this.props.searchValue);
            }
        } else if (displayKey.length > 0) {
            if (this.isSelectionCell(cellIndex)) {
                displayVal = getReactLink({
                    id: this.props.id + '_' + cellIndex + '_link',
                    href: '#',
                    style: {},
                    row: this.props.row,
                    text: rowCell[displayKey],
                    onClick: this.onLinkClick,
                });
            } else {
                displayVal = rowCell[displayKey];
            }
        }

        return <React.Fragment>
            {((addSelectColumnBefore) ? this.getSelectCell() : null)}
            {((addDeleteColumnBefore) ? this.getDeleteCell() : null)}
            {((addSortColumnBefore) ? this.getSortCell() : null)}
            {(canDisplayCell) ? <ReactCell id={cellID} css={cellCSS} displayValue={displayVal} style={cellStyle} title={cellTitle} /> : ''}
            {(this.getAddColumnDivider(header)) ? this.getRowDivider(rowCell, cellIndex, header, rowIndex) : null}
        </React.Fragment>;
    }

    render() {
        let rowHighlightClass = (null != this.props.hightlightSelectedRowCSS) ? this.props.hightlightSelectedRowCSS(this.props.row, this.props.rowIndex) : 'copia_tableHighlightColor_b';

        if (null != this.props.rowHasFocusCSS && this.props.rowHasFocus) {
            rowHighlightClass = this.props.rowHasFocusCSS(this.props.row, this.props.rowIndex);
        }

        const rowClasses = (this.props.doHighlightRow) ? (' ' + rowHighlightClass) : '';

        return(
            <tr data-rowIndex={this.props.rowIndex} data-overallIndex={this.props.overallIndex}  ref={this.props.rowReference} key={this.props.overallIndex} id={this.props.id} data-name={this.props.name} className={this.props.rowClass + rowClasses + ((this.props.enableDragAndDrop) ? ' ui-sortable-handle' : '')} style={this.props.rowStyle} draggable={((this.props.disabled) ? false : (this.props.enableDragAndDrop || this.props.selectRecordsWithRowDrag))} onDragStart={this.startDragRow} onDragEnd={this.stopDragRow} onDragEnter={this.duringDragRow} onDragOver={this.onDragOver} onClick={this.onRowClick} onDoubleClick={this.onDblClick}>
                {this.props.headers.map((header, headerIndex) => this.buildCell(this.props.row, this.props.rowIndex, header, headerIndex))}
                {((this.props.addSelectColumn && this.props.selectColumnIndex == -1) ? this.getSelectCell() : null)}
                {((this.props.addDeleteColumn && this.props.deleteColumnIndex == -1) ? this.getDeleteCell() : null)}
                {((this.props.enableDragAndDrop && this.props.sortColumnIndex == -1) ? this.getSortCell() : null)}
            </tr>
        );
    }
}

export interface ReactTableState {
    storedData: any;
    rows: any[];
    filteredRows: any[];
    highlightSelectedRow: number;
    toolBarNumToDisplay: number;
    toolBarNumToDisplayTyped: number;
    toolBarPageNumber: number;
    toolBarPageNumberTyped: number;
    rowIsDragging: boolean;
    showTable: boolean;
    dragRow: any;
    headerIsDragging: boolean;
    dragHeader: any;
    scrollBarPosition: number;
    zIndex: number;
}

export interface ReactTableData {
    id?: string;
    useRowDataStorage?: boolean;
    storedData?: any;
    rows?: any[];
    filteredRows?: any[];
    headers?: any[];
    headersCSS?: string;
    rowsCSS?: (row: any, rowIndex: number, isDraggingRow: boolean) => string;
    rowsStyle?: (row: any, rowIndex: number) => {};
    highlightSelectedRow?: number; // -1 to turn off
    hightlightSelectedRowCSS?: (row: any, rowIndex: number) => string;
    rowHasFocusCSS?: (row: any, rowIndex: number) => string;
    selectRecordWithRowClick?: boolean;
    tableLabel?: string;
    showTable?: boolean;
    isSearchAsYouType?: boolean;
    hideSAYTOnSelect?: boolean;
    selectColumns?: [];
    addSelectColumn?: boolean;
    selectColumnIndex?: number; // -1 to add to the end
    toolBarDisplayHeader?: boolean; // If toolBarDisplayHeader and toolBarDisplayFooter are false then there is no limit, all rows will display
    toolBarDisplayFooter?: boolean;
    toolBarDisplayCompact?: boolean;
    toolBarDisplayTotalRowsSelected?: boolean;
    toolBarPageNumber?: number;
    toolBarNumToDisplay?: number;
    toolBarPrintListOnClick?: (filteredRows?: any[]) => void;
    toolBarExportListOnClick?: (filteredRows?: any[]) => void;
    toolBarManageColumnsOnClick?: () => void;
    toolBarStyle?: {};
    toolBarCompactStyle?: {};
    enableDragAndDrop?: boolean;
    selectRecordsWithRowDrag?: boolean;
    sortColumnIndex?: number; // -1 to add to the end
    onDropEvent?: (event: any) => void;
    onDuringDragEvent?: (event: any, row: any, dragOverRow: any) => void;
    onSortEvent?: () => void;
    css?: string;
    style?: {};
    toolBarUpdate?: (state: ReactTableState) => void;
    sortUpdate?: (state: ReactTableState, onLoad: boolean) => void;
    onRefresh?: () => {};
    onToolBarRefresh?: () => {};
    refreshID?: string;
    toolBarRefreshID?: string;
    disabled?: boolean;
    disableHeaderScrolling?: boolean;
    onSelectCellClick?: (rowOBJ: any, shiftKey: boolean, ctrlKey: boolean, applySelection: boolean, lastRowObj: any) => void;
    selectHeaderClick?: () => void;
    clearSelectionClick?: () => void;
    clearButtonTabIndex?: null;
    addDeleteColumn?: boolean;
    deleteButtonStyle?: (row: any, rowIndex: number) => {};
    deleteButtonTabIndex?: null;
    deleteColumnIndex?: number; // -1 to add to the end
    onDelete?: (rowIndex: number) => number;
    lockedRows?: [];
    disableRow?: (row: any, rowIndex: number) => boolean;
    disableDelete?: (row: any, rowIndex: number) => boolean;
    toolBarNumToDisplayTyped?: number;
    toolBarPageNumberTyped?: number;
    noRecordsSelectedText?: string;
    addCustomFilterOptions?: (storedData?: any, filteredRows?: any[]) => {};
    addCustomToolBarOptions?: (storedData?: any) => {};
    isSelectedKey?: string;
    hiddenSelectedKey?: string;
    hiddenSelectedKeyDelimiter?: string;
    dataKey?: string;
    onRowDoubleClick?: (rowOBJ: any) => void;
    customFilterCSS?: string;
    getTotalSelected?: () => number;
    onSAYTTableDisplayEvent?: (saytTableRef: object) => void;
    divSAYTWindowCSS?: null;
    divTableShellCSS?: null;
    divTableContainerShellCSS?: null;
    emptyRowCSS?: string;
    overrideSortID?: string;
    overrideSortName?: string;
    storedDataAsJSONArray?: boolean;
    newJSONData?: (row: any, rowIndex: number, jsonData: any) => {};
    overrideRowID?: (row: any, rowIndex: number, overallIndex: number) => string;
    overrideRowName?: (row: any, rowIndex: number, overallIndex: number) => string;
    deleteButtonID?: (row: any, rowIndex: number, overallIndex: number) => string;
    deleteButtonName?: (row: any, rowIndex: number, overallIndex: number) => string;
    selectCheckBoxID?: (row: any, rowIndex: number, overallIndex: number) => string;
    selectCheckBoxName?: (row: any, rowIndex: number, overallIndex: number) => string;
    overrideTableEntriesText?: string;
    overrideScrollIntoView?: (element: any, row: any, rowIndex: number) => void;
    onScroll?: (rowIndex: number) => void;
    searchValue?: string;
    toolBarDisplayTotalCSS?: string;
    toolBarDisplayTotalStyle?: {};
    onSelectionChange?: (totalSelected: number) => void;
    overrideToolBarInfoText?: (totalRows: number, startPos: number, endPos: number, totalPages: number, page: number) => {};
    onTableScroll?: (scrollTop: number, scrollHeight: number, clientHeight: number, selectIndex: number, numberOfRowsDisplayed: number, newZIndex: number) => void;
    onKeyDown?: (rowOBJ: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bALT: boolean) => null;
    onKeyUp?: (rowOBJ: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean, bALT: boolean) => null;
    stopPropagationOnKeyPress?: (rowOBJ: any, rowIndex: number, keyPressed: string, bOnKeyUp: boolean, bShift: boolean, bCTRL: boolean, bALT: boolean) => boolean;
    onDuringDragHeader?: (event: any, header: any, dragOverHeader: any, headerCellRef: RefObject<any>) => void;
    onDropHeaderEvent?: (event: any, header: any, dragOverHeader: any) => void;
    deleteColumnHeader?: "";
    updatePaging?: (pageNumber: number) => void;
    toolBarDisablePaging?: boolean;
    toolBarDisplayTotal?: () => number;
}

// React Table used internally by ReactSearchAsYouType, ReactMultiSelectSearchAsYouType, and ReactTableShell
export class ReactTable extends React.Component<ReactTableData> {
    tableRef: RefObject<any>;
    saytTableRef: RefObject<any>;
    highlightRowRef: RefObject<any>;
    headerRef: RefObject<any>;
    pageNumberHeaderRef: RefObject<any>;
    pageNumberFooterRef: RefObject<any>;
    useHighlightSelectedRow: boolean;
    lastSelectedRowIndex: number;
    useRowDataStorage: boolean;
    storedDataAsJSONArray: boolean;

    constructor(props: ReactTableData) {
        super(props);

        // Binding is necessary to allow these functions access to the State data
        this.sortTable = this.sortTable.bind(this);
        this.setNumberToDisplay = this.setNumberToDisplay.bind(this);
        this.changeNumberOfEntries = this.changeNumberOfEntries.bind(this);
        this.changePageNumber = this.changePageNumber.bind(this);
        this.setPageNumber = this.setPageNumber.bind(this);
        this.updatePageNumber = this.updatePageNumber.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onShowEntriesKeyPress = this.onShowEntriesKeyPress.bind(this);
        this.onPageNumberKeyPress = this.onPageNumberKeyPress.bind(this);
        this.toolBarPageLeft = this.toolBarPageLeft.bind(this);
        this.toolBarPageRight = this.toolBarPageRight.bind(this);
        this.toolBarPageBeginning = this.toolBarPageBeginning.bind(this);
        this.toolBarPageEnd = this.toolBarPageEnd.bind(this);
        this.onDragStartHandler = this.onDragStartHandler.bind(this);
        this.onDragStopHandler = this.onDragStopHandler.bind(this);
        this.onDragHandler = this.onDragHandler.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onToolBarRefresh = this.onToolBarRefresh.bind(this);
        this.onPageNumberRefresh = this.onPageNumberRefresh.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.buildRows = this.buildRows.bind(this);
        this.clearSelection = this.clearSelection.bind(this);
        this.clickPrintList = this.clickPrintList.bind(this);
        this.clickExportList = this.clickExportList.bind(this);
        this.clickManageColumns = this.clickManageColumns.bind(this);
        this.getTotalSelected = this.getTotalSelected.bind(this);
        this.onKeyUp = this.onKeyPress.bind(this);
        this.onDuringDragHeader = this.onDuringDragHeader.bind(this);
        this.onDragHeaderStart = this.onDragHeaderStart.bind(this);
        this.onDragHeaderStop = this.onDragHeaderStop.bind(this);

        this.tableRef = React.createRef();
        this.saytTableRef = React.createRef();
        this.highlightRowRef = React.createRef();
        this.headerRef = React.createRef();
        this.pageNumberHeaderRef = React.createRef();
        this.pageNumberFooterRef = React.createRef();

        this.lastSelectedRowIndex = -1; // Starts as not set but will become set as soon as someone clicks on the table
        this.useRowDataStorage = props.useRowDataStorage;
        this.storedDataAsJSONArray = props.storedDataAsJSONArray;
        this.useHighlightSelectedRow = props.highlightSelectedRow >= 0;

        this.state = {
            storedData: props.storedData,
            rows: props.rows,
            filteredRows: props.filteredRows,
            highlightSelectedRow: props.highlightSelectedRow,
            toolBarNumToDisplay: props.toolBarNumToDisplay,
            toolBarNumToDisplayTyped: props.toolBarNumToDisplay,
            toolBarPageNumber: props.toolBarPageNumber,
            toolBarPageNumberTyped: props.toolBarPageNumber,
            rowIsDragging: false,
            showTable: props.showTable,
            dragRow: null,
            headerIsDragging: false,
            dragHeader: null,
            scrollBarPosition: 0,
            zIndex: (props.isSearchAsYouType && props.showTable) ? getHighestZIndex() + 1 : null,
        };
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactTableData) {
        // Only update if props actually changed - prevents overwriting internal sort state
        const propsChanged = (
            props.showTable !== this.props.showTable ||
            props.rows !== this.props.rows ||
            props.filteredRows !== this.props.filteredRows ||
            props.headers !== this.props.headers ||
            props.storedData !== this.props.storedData ||
            props.highlightSelectedRow !== this.props.highlightSelectedRow ||
            props.toolBarPageNumber !== this.props.toolBarPageNumber ||
            props.toolBarNumToDisplayTyped !== this.props.toolBarNumToDisplayTyped ||
            props.toolBarPageNumberTyped !== this.props.toolBarPageNumberTyped
        );

        if (!propsChanged) {
            return;
        }

        // const headerIndex = this.indexOfSortColumn(props.headers);
        // Get a list of sort orders being used
        let sortOrderList: number[] = [];
        props.headers.map((header: TableHeaderCellData) => {
            if (null != header.sortOrder && header.sortOrder > 0) {
                sortOrderList.push(header.sortOrder);
            }
        });

        // Sort the list of sort orders, so we can figure out the new sort orders for each header
        sortOrderList = sortOrderList.sort((order1, order2) => order1 > order2 ? 1 : -1);

        this.setState({
            showTable: props.showTable,
            rows: ((sortOrderList.length >= 0) ? this.sortHeaders(props.headers, props.rows, sortOrderList) : props.rows),
            storedData: props.storedData,
            filteredRows: ((sortOrderList.length >= 0) ? this.sortHeaders(props.headers, props.filteredRows, sortOrderList) : props.filteredRows),
            highlightSelectedRow: props.highlightSelectedRow,
            toolBarPageNumber: props.toolBarPageNumber,
            toolBarNumToDisplayTyped: props.toolBarNumToDisplayTyped,
            toolBarPageNumberTyped: props.toolBarPageNumberTyped,
        }, () => {
            if (null != this.props.onSAYTTableDisplayEvent && this.saytTableRef.current) {
                this.props.onSAYTTableDisplayEvent($(this.saytTableRef.current));
            }
            this.executeScroll();
        });
    }

    componentDidMount() {
        this.sortTable(this.props.headers, true); // Sort the table on load (if a header has a sortOrder specified)

        if (null != this.props.onSAYTTableDisplayEvent && this.saytTableRef.current) {
            this.props.onSAYTTableDisplayEvent($(this.saytTableRef.current));
        }
    }

    // Get the index of the row in the rows array
    indexOfRow(row: any) {
        for (let i = 0; i < (this.state as ReactTableState).rows.length; i++) {
            if (row == (this.state as ReactTableState).rows[i] as any) {
                return i;
            }
        }

        return -1;
    }

    // Get the index of the row in the filteredRows array
    indexOfFilteredRow(row: any) {
        for (let i = 0; i < (this.state as ReactTableState).filteredRows.length; i++) {
            if (row == (this.state as ReactTableState).filteredRows[i] as any) {
                return i;
            }
        }

        return -1;
    }

    onScroll(event: React.UIEvent<HTMLDivElement, UIEvent>) {
        if (this.headerRef.current && event.target == this.tableRef.current) {
            const newZIndex = getHighestZIndex($(event.target).parent()) + 1;
            const position = $(event.target).scrollTop();
            if (!this.props.disableHeaderScrolling) {

                $(this.headerRef.current).css({
                    position: 'relative',
                    top: position,
                    zIndex: newZIndex
                });
            }

            if (null != this.props.onScroll) {
                const selectIndex = (this.state as ReactTableState).highlightSelectedRow + (((this.state as ReactTableState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
                if (selectIndex >= 0 && selectIndex < (this.state as ReactTableState).filteredRows.length) {
                    this.props.onScroll(selectIndex);
                }
            }

            if (null != this.props.onTableScroll) {
                const { scrollTop, scrollHeight, clientHeight } = this.tableRef.current;
                const selectIndex = (this.state as ReactTableState).highlightSelectedRow + (((this.state as ReactTableState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
                this.props.onTableScroll(scrollTop, scrollHeight, clientHeight, selectIndex, (this.state as ReactTableState).filteredRows.length, newZIndex);
            }

            this.setState({
                scrollBarPosition: position
            });
        }
    }

    indexOfSortColumn(headers: any[]) {
        for (let i = 0; i < headers.length; i++) {
            if (null != headers[i].sortDirection) {
                if (headers[i].sortDirection == HeaderSortDirection.asc || headers[i].sortDirection == HeaderSortDirection.desc) {
                    return i;
                }
            }
        }
        return -1;
    }

    // Get the next row for the highlighted selected row to highlight
    getNextRow(row: number, keyUp: boolean, totalRows: number) {
        let nextRow = row;
        if (keyUp) {
            if (nextRow > 0) {
                nextRow--;
            }
        } else {
            if (nextRow < (totalRows - 1)) {
                nextRow++;
            }
        }
        return nextRow;
    }

    executeScroll() {
        if (!(this.state as ReactTableState).rowIsDragging && !(this.state as ReactTableState).headerIsDragging) {
            // Scroll the highlighted selected row into view
            if (null != this.highlightRowRef.current && (this.state as ReactTableState).highlightSelectedRow >= 0) {
                if (null != this.props.overrideScrollIntoView) {
                    const selectIndex = (this.state as ReactTableState).highlightSelectedRow + (((this.state as ReactTableState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
                    if (selectIndex >= 0 && selectIndex < (this.state as ReactTableState).filteredRows.length) {
                        this.props.overrideScrollIntoView(this.highlightRowRef.current, (this.state as ReactTableState).filteredRows[selectIndex], selectIndex);
                    }
                } else {
                    this.highlightRowRef.current.scrollIntoView({block: 'center'});
                }
            }
        }
    }

    // Handle On Key Down Events
    onKeyPress(event: any) {
        if (null != this.props.onKeyDown) {
            const selectIndex = (this.state as ReactTableState).highlightSelectedRow + (((this.state as ReactTableState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactTableState).filteredRows.length) ?  (this.state as ReactTableState).filteredRows[(this.state as ReactTableState).highlightSelectedRow] : null;
            this.props.onKeyDown(selectRow, selectIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
        }

        const keyUp = event.key == 'ArrowUp';
        const keyDown = event.key == 'ArrowDown';
        const keyLeft = event.key == 'ArrowLeft';
        const keyRight = event.key == 'ArrowRight';
        const keyTab = event.key == 'Tab';
        const keyEnter = event.key == 'Enter';

        let keyPressed = false;
        if  (this.useHighlightSelectedRow && (keyUp || keyDown)) {
            // Move the Highlight Selected Row up and down
            let updateHighlightPosition = true;
            let newSelectedRow = this.getNextRow((this.state as ReactTableState).highlightSelectedRow, keyUp, (this.state as ReactTableState).filteredRows.length);
            let pageNumber = (this.state as ReactTableState).toolBarPageNumber;
            if (keyUp && pageNumber > 1 && (this.state as ReactTableState).highlightSelectedRow == 0) {
                newSelectedRow = (this.state as ReactTableState).toolBarNumToDisplay - 1;
                pageNumber--;
            } else if (keyDown) {
                if ((newSelectedRow + ((pageNumber - 1) * (this.state as ReactTableState).toolBarNumToDisplay)) <= ((this.state as ReactTableState).filteredRows.length - 1)) {
                    if (newSelectedRow >= (this.state as ReactTableState).toolBarNumToDisplay) {
                        const totalPages = Math.ceil((this.state as ReactTableState).filteredRows.length / (this.state as ReactTableState).toolBarNumToDisplay);
                        if (pageNumber < totalPages) {
                            newSelectedRow = 0;
                            pageNumber++;
                        } else {
                            updateHighlightPosition = false;
                        }
                    }
                } else {
                    updateHighlightPosition = false;
                }
            }

            keyPressed = true;

            if (updateHighlightPosition) {
                this.setState({
                    highlightSelectedRow: newSelectedRow,
                    toolBarPageNumber: pageNumber,
                    toolBarPageNumberTyped: pageNumber
                }, () => {
                    this.updateState(true);
                });
            }
        } else if ((keyLeft || keyRight) && (this.getIsUsingPaging() || this.props.isSearchAsYouType)) {
            // Move the tool bar left and right
            if (keyLeft) {
                this.toolBarPageLeft();
                keyPressed = true;
            } else if (keyRight) {
                this.toolBarPageRight();
                keyPressed = true;
            }
        } else if (keyEnter) {
            // Select the highlighted selected row on ENTER
            if (!this.props.disabled && this.useHighlightSelectedRow && this.props.addSelectColumn && null != this.props.onSelectCellClick) {
                const selectIndex = (this.state as ReactTableState).highlightSelectedRow + (((this.state as ReactTableState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
                if (selectIndex >= 0 && selectIndex < (this.state as ReactTableState).filteredRows.length) {
                    this.props.onSelectCellClick((this.state as ReactTableState).filteredRows[selectIndex], event.shiftKey, event.ctrlKey, true, null);
                }
                keyPressed = true;
            }
        }

        if (keyPressed) {
            event.preventDefault();
        }

        if (null != this.props.stopPropagationOnKeyPress) {
            const selectIndex = (this.state as ReactTableState).highlightSelectedRow + (((this.state as ReactTableState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactTableState).filteredRows.length) ?  (this.state as ReactTableState).filteredRows[(this.state as ReactTableState).highlightSelectedRow] : null;
            if (this.props.stopPropagationOnKeyPress(selectRow, selectIndex, event.key, false, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    onKeyUp(event: any) {
        if (null != this.props.onKeyUp) {
            const selectIndex = (this.state as ReactTableState).highlightSelectedRow + (((this.state as ReactTableState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactTableState).filteredRows.length) ?  (this.state as ReactTableState).filteredRows[(this.state as ReactTableState).highlightSelectedRow] : null;
            this.props.onKeyUp(selectRow, selectIndex, event.key, event.shiftKey, event.ctrlKey, event.altKey);
        }
        if (null != this.props.stopPropagationOnKeyPress) {
            const selectIndex = (this.state as ReactTableState).highlightSelectedRow + (((this.state as ReactTableState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactTableState).filteredRows.length) ?  (this.state as ReactTableState).filteredRows[(this.state as ReactTableState).highlightSelectedRow] : null;
            if (this.props.stopPropagationOnKeyPress(selectRow, selectIndex, event.key, true, event.shiftKey, event.ctrlKey, event.altKey)) {
                event.stopPropagation();
            }
        }
    }

    onPageNumberKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key == 'Enter') {
            this.setPageNumber(event);
        } else {
            this.onKeyPress(event);
        }
    }

    onShowEntriesKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key == 'Enter') {
            // If we are using the Selected Highlight row and there is a select column then add the selection on Enter
            if (this.useHighlightSelectedRow && this.props.addSelectColumn) {
                this.setNumberToDisplay(event);
                this.onKeyPress(event);
            } else {
                this.setNumberToDisplay(event);
            }
        } else {
            this.onKeyPress(event);
        }
    }

    getCellSortValue(header: any, cell: any) {
        if (null != cell && null != header) {
            const displayKey = (null != header.displayKey) ? header.displayKey : '';

            if (cell[displayKey]) {
                if (typeof cell[displayKey] == 'string') {
                    return cell[displayKey];
                } else if (typeof cell[displayKey] == 'number') {
                    return cell[displayKey].toString();
                } else if (typeof cell[displayKey] == 'boolean') {
                    return (cell[displayKey]) ? '1' : '0';
                } else if (null != cell[displayKey].props) {
                    if (cell[displayKey].props.value) {
                        return '' + cell[displayKey].props.value;
                    }
                }
            }
        }

        return '';
    }

    sortColumn(header: any, headerIndex: number, a: any, b: any) {
        if (null != header.sortOverride) { // Custom Sort Column
            return header.sortOverride(header.sortDirection, headerIndex, a, b);
        } else {
            if (null != header.sortOption && header.sortOption == 'numeric') { // Numeric Sort Column
                let displayKey = '';
                if (header) {
                    displayKey = (null != header.displayKey) ? header.displayKey : '';
                }

                if (displayKey.length > 0) {
                    if (header.sortDirection == HeaderSortDirection.asc) {
                        return a[displayKey] - b[displayKey];
                    } else {
                        return b[displayKey] - a[displayKey];
                    }
                } else {
                    return 0;
                }

            } else {
                // String Sort Column
                const displayVal1 = this.getCellSortValue(header, a).toLowerCase();
                const displayVal2 = this.getCellSortValue(header, b).toLowerCase();

                const compareVal = displayVal1.localeCompare(displayVal2);
                if (compareVal == 0) {
                    return 0;
                } else if (header.sortDirection == HeaderSortDirection.asc) {
                    return ((compareVal == 1) ? 1 : -1);
                } else {
                    return ((compareVal == -1) ? 1 : -1);
                }
            }
        }
    }

    getHeaderIndexWithSortOrder(headers: any[], sortOrder: number) {
        for (let i = 0; i < headers.length; i++) {
            if (null != headers[i].sortOrder && headers[i].sortOrder == sortOrder) {
                return i;
            }
        }
        return -1;
    }

    sortHeaders(headers: any[], rows: any[], sortOrderList: number[]) {
        return rows.sort((a: any, b: any) => {
            for (let i = 0; i < sortOrderList.length; i++) {
                const headerIndex = this.getHeaderIndexWithSortOrder(headers, sortOrderList[i]);
                if (headerIndex > -1) {
                    const sortVal = this.sortColumn(headers[headerIndex], headerIndex, a, b);
                    if (sortVal != 0) {
                        return sortVal;
                    }
                }
            }
        });
    }

    sortTable(headers: any, onLoad: boolean) {
        this.lastSelectedRowIndex = -1;

        // Get a list of sort orders being used
        let sortOrderList: number[] = [];
        headers.map((header: TableHeaderCellData) => {
            if (null != header.sortOrder && header.sortOrder > 0) {
                sortOrderList.push(header.sortOrder);
            }
        });

        // Sort the list of sort orders, so we can figure out the new sort orders for each header
        sortOrderList = sortOrderList.sort((order1, order2) => order1 > order2 ? 1 : -1);

        if (onLoad) {
            this.setState(() => ({
                rows: this.sortHeaders(headers, (this.state as ReactTableState).rows, sortOrderList),
                filteredRows: this.sortHeaders(headers, (this.state as ReactTableState).filteredRows, sortOrderList),
            }), () => {
                if (null != this.props.sortUpdate) {
                    this.props.sortUpdate((this.state as ReactTableState), true);
                }
            });
        } else {
            this.setState(() => ({
                rows: this.sortHeaders(headers, (this.state as ReactTableState).rows, sortOrderList),
                filteredRows: this.sortHeaders(headers, (this.state as ReactTableState).filteredRows, sortOrderList),
                toolBarPageNumber: 1,
                toolBarPageNumberTyped: 1,
                highlightSelectedRow: ((this.useHighlightSelectedRow) ? 0 : -1)
            }), () => {
                if (null != this.props.sortUpdate) {
                    this.props.sortUpdate((this.state as ReactTableState), false);
                }
            });
        }

        if (this.tableRef.current) {
            this.tableRef.current.scrollTo({top: 0});
        }

        if (null != this.props.onSortEvent) {
            this.props.onSortEvent();
        }
    }

    setNumberToDisplay(event: any) {
        const enteredNumber = parseInt(event.target.value, 10);
        if (enteredNumber > 0) {
            if ((this.state as ReactTableState).toolBarNumToDisplay != enteredNumber) {
                this.setState(() => ({
                    toolBarNumToDisplay: enteredNumber,
                    toolBarPageNumber: 1,
                    highlightSelectedRow: ((this.useHighlightSelectedRow) ? 0 : -1)
                }), () => {
                    this.updateState(true);
                });
            }
        } else {
            this.setState(() => ({
                toolBarNumToDisplay: this.props.toolBarNumToDisplay,
                toolBarNumToDisplayTyped: this.props.toolBarNumToDisplay,
                toolBarPageNumber: 1,
                highlightSelectedRow: ((this.useHighlightSelectedRow) ? 0 : -1)
            }), () => {
                this.updateState(true);
            });
        }
    }

    changeNumberOfEntries(event: React.ChangeEvent<HTMLInputElement>) {
        const enteredNumber = parseInt(event.target.value, 10);
        if (enteredNumber > 0) {
            this.setState(() => ({
                toolBarNumToDisplayTyped: enteredNumber
            }));
        } else {
            this.setState(() => ({
                toolBarNumToDisplayTyped: ''
            }));
        }
    }

    toolBarPageLeft() {
        this.setState((prev: ReactTableData) => ({
            toolBarPageNumber: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            toolBarPageNumberTyped: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? ((prev.toolBarPageNumber > 1) ? 0 : (this.state as ReactTableState).highlightSelectedRow) : -1)
        }), () => {
            this.updateState(true);
        });
    }

    updateState(updateToolBar: boolean) {
        this.lastSelectedRowIndex = -1;

        if (updateToolBar && null != this.props.toolBarUpdate) {
            this.props.toolBarUpdate((this.state as ReactTableState));
        }

        if(null != this.props.updatePaging) {
            this.props.updatePaging((this.state as ReactTableState).toolBarPageNumber);
        }

        this.executeScroll();

        if (null != this.props.onSAYTTableDisplayEvent && this.saytTableRef.current) {
            this.props.onSAYTTableDisplayEvent($(this.saytTableRef.current));
        }
    }

    toolBarPageRight() {
        const totalPages = Math.ceil((this.state as ReactTableState).filteredRows.length / (this.state as ReactTableState).toolBarNumToDisplay);
        this.setState(() => ({
            toolBarPageNumber: (((this.state as ReactTableState).toolBarPageNumber < totalPages) ? (this.state as ReactTableState).toolBarPageNumber + 1 : (this.state as ReactTableState).toolBarPageNumber),
            toolBarPageNumberTyped: (((this.state as ReactTableState).toolBarPageNumber < totalPages) ? (this.state as ReactTableState).toolBarPageNumber + 1 : (this.state as ReactTableState).toolBarPageNumber),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? (((this.state as ReactTableState).toolBarPageNumber < totalPages) ? 0 : (this.state as ReactTableState).highlightSelectedRow) : -1)
        }), () => {
            this.updateState(true);
        });
    }

    toolBarPageBeginning() {
        this.setState(() => ({
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1
        }), () => {
            this.updateState(true);
        });
    }

    toolBarPageEnd() {
        const totalPages = Math.ceil((this.state as ReactTableState).filteredRows.length / (this.state as ReactTableState).toolBarNumToDisplay);
        this.setState(() => ({
            toolBarPageNumber: totalPages,
            toolBarPageNumberTyped: totalPages
        }), () => {
            this.updateState(true);
        });
    }

    changePageNumber(event: React.ChangeEvent<HTMLInputElement>) {
        const enteredNumber = parseInt(event.target.value, 10);
        if (enteredNumber > 0) {
            this.setState(() => ({
                toolBarPageNumberTyped: enteredNumber
            }), () => {
                this.updateState(false);
            });
        } else {
            this.setState(() => ({
                toolBarPageNumberTyped: ''
            }), () => {
                this.updateState(false);
            });
        }
    }

    updatePageNumber(pageNumber: number) {
        if (pageNumber > 0) {
            if ((this.state as ReactTableState).toolBarPageNumber != pageNumber) {
                const totalPages = Math.ceil((this.state as ReactTableState).filteredRows.length / (this.state as ReactTableState).toolBarNumToDisplay);
                if (pageNumber <= totalPages) {
                    this.setState(() => ({
                        toolBarPageNumber: pageNumber,
                        highlightSelectedRow: ((this.useHighlightSelectedRow) ? 0 : -1)
                    }), () => {
                        this.updateState(true);
                    });
                } else {
                    this.setState(() => ({
                        toolBarPageNumber: totalPages,
                        toolBarPageNumberTyped: totalPages,
                        highlightSelectedRow: ((this.useHighlightSelectedRow) ? 0 : -1)
                    }), () => {
                        this.updateState(true);
                    });
                }
            }
        } else {
            this.setState(() => ({
                toolBarPageNumber: this.props.toolBarPageNumber,
                toolBarPageNumberTyped: this.props.toolBarPageNumber,
                highlightSelectedRow: ((this.useHighlightSelectedRow) ? 0 : -1)
            }), () => {
                this.updateState(true);
            });
        }
    }

    setPageNumber(event: any)  {
        const enteredNumber = parseInt(event.target.value, 10);
        this.updatePageNumber(enteredNumber);
    }

    onRefresh() {
        if (null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState(() => ({
            rows: (this.state as ReactTableState).rows,
            filteredRows: (this.state as ReactTableState).filteredRows
        }), () => {
            if (null != this.props.onSAYTTableDisplayEvent && this.saytTableRef.current) {
                this.props.onSAYTTableDisplayEvent($(this.saytTableRef.current));
            }
        });
    }

    onToolBarRefresh() {
        if (null != this.props.onToolBarRefresh) {
            this.props.onToolBarRefresh();
        }

        this.setState(() => ({
            rows: (this.state as ReactTableState).rows,
            filteredRows: (this.state as ReactTableState).filteredRows
        }), () => {
            if (null != this.props.onSAYTTableDisplayEvent && this.saytTableRef.current) {
                this.props.onSAYTTableDisplayEvent($(this.saytTableRef.current));
            }
        });
    }

    onPageNumberRefresh(isHeader: boolean) {
        if (isHeader) {
            if (null != this.pageNumberHeaderRef) {
                this.updatePageNumber(parseInt($(this.pageNumberHeaderRef.current).val() as string, 10));
            }
        } else {
            if (null != this.pageNumberFooterRef) {
                this.updatePageNumber(parseInt($(this.pageNumberFooterRef.current).val() as string, 10));
            }
        }
    }

    clearSelection() {
        if (null != this.props.clearSelectionClick) {
            this.props.clearSelectionClick();
        }
    }

    getTotalSelected() {
        let count = 0;
        for (let i = 0; i < (this.state as ReactTableState).rows.length; i++) {
            const row = (this.state as ReactTableState).rows[i];
            if (null != row.isSelected && row.isSelected) {
                count++;
            }
        }
        if (null != this.props.onSelectionChange) {
            this.props.onSelectionChange(count);
        }
        return count;
    }

    buildTotalRowsSelected() {
        const toolBarDisplayTotalCSS = (null != this.props.toolBarDisplayTotalCSS) ? this.props.toolBarDisplayTotalCSS : 'lightGray2-bg ui-corner-tl ui-corner-tr';
        const toolBarDisplayTotalStyle = (null != this.props.toolBarDisplayTotalStyle) ? this.props.toolBarDisplayTotalStyle : {border: '1px solid var(--lightGray2)', borderBottom: 0, color: 'black', fontWeight: 'bold', padding: '5px', position: 'relative'};

        return <div className={(this.props.toolBarDisplayTotalRowsSelected) ? 'align-obj-right' : 'align-obj-right categoryAllHide'} style={{paddingRight: '10px', height: ((this.props.disabled) ? '16px' : '19px')}}>
            <span className={toolBarDisplayTotalCSS} style={toolBarDisplayTotalStyle}>
                <span>Total rows selected: </span>
                <span id={this.props.id + '_totalSelected'} style={{paddingRight: '5px'}}>{this.getTotalSelected()}</span>
                <span>{getReactButton({id: this.props.id + '_clearSelection', css: (this.props.disabled) ? 'categoryAllHide' : '', onClick: this.clearSelection, text: 'Clear', tabIndex: this.props.clearButtonTabIndex})}</span>
            </span>
        </div>;
    }

    clickPrintList() {
        if (null != this.props.toolBarPrintListOnClick) {
            this.props.toolBarPrintListOnClick((this.state as ReactTableState).filteredRows);
        }
    }

    clickExportList() {
        if (null != this.props.toolBarExportListOnClick) {
            this.props.toolBarExportListOnClick((this.state as ReactTableState).filteredRows);
        }
    }

    clickManageColumns() {
        if (null != this.props.toolBarManageColumnsOnClick) {
            this.props.toolBarManageColumnsOnClick();
        }
    }

    getToolBarPrintListOption() {
        let rightPX = '15px';
        if ((null != this.props.toolBarExportListOnClick) && (null != this.props.toolBarManageColumnsOnClick)) {
            rightPX = '65px';
        } else if ((null != this.props.toolBarExportListOnClick) || (null != this.props.toolBarManageColumnsOnClick)) {
            rightPX = '40px';
        }

        return <div style={{position: 'absolute', top: '0px', right: rightPX}}>
            <i id={this.props.id + '_printList'} className="fas fa-print fa-lg clickable column-picker" title="Print List" role="button" onClick={this.clickPrintList}></i>
        </div>;
    }

    getToolBarExportListOption() {
        let rightPX = '15px';
        if (null != this.props.toolBarManageColumnsOnClick) {
            rightPX = '40px';
        }

        return <div style={{position: 'absolute', top: '0px', right: rightPX}}>
            <i id={this.props.id + 'exportList'} className="fas fa-download fa-lg clickable column-picker" title="Export List" role="button" onClick={this.clickExportList}></i>
        </div>;
    }

    getToolBarManageColumnsOption() {
        return <div style={{position: 'absolute', top: '0px', right: '15px'}}>
            <i id={this.props.id + 'manageColumns'} className="fas fa-columns fa-lg clickable column-picker" title="Manage Columns" role="button" onClick={this.clickManageColumns}></i>
        </div>;
    }

    getToolBarListOptions() {
        if (null != this.props.toolBarPrintListOnClick || null != this.props.toolBarExportListOnClick || null != this.props.toolBarManageColumnsOnClick || null != this.props.addCustomToolBarOptions) {
            return <div style={{width: '0px', height: '0px', position: 'relative', float: 'right', display: 'inline', paddingLeft: '50px'}}>
                {(null != this.props.toolBarPrintListOnClick) ? this.getToolBarPrintListOption() : null}
                {(null != this.props.toolBarExportListOnClick) ? this.getToolBarExportListOption() : null}
                {(null != this.props.toolBarManageColumnsOnClick) ? this.getToolBarManageColumnsOption() : null}
                {(null != this.props.addCustomToolBarOptions) ? this.props.addCustomToolBarOptions((this.state as ReactTableState).storedData) : null}
            </div>;
        } else {
            return null;
        }
    }

    buildToolBar(isHeader: boolean) {
        const totalRows = (this.state as ReactTableState).filteredRows.length;
        if(this.props.toolBarDisablePaging) {
            const overallTotal = (null != this.props.toolBarDisplayTotal) ? this.props.toolBarDisplayTotal() : totalRows;
            return <React.Fragment>
                {getReactButton({id: (isHeader) ? this.props.id + "_headerPageNum_refresh" : this.props.id + "_footerPageNum_refresh", css: "categoryAllHide", onClick: () => this.onPageNumberRefresh(isHeader), text: "HIDDEN REFRESH BUTTON"})}
                <div id={(this.props.id + ((isHeader) ? "_toolBarHeader":"_toolBarFooter"))} className={"fg-toolbar ui-toolbar ui-widget-header " + ((isHeader) ? "ui-corner-tl ui-corner-tr ui-helper-clearfix datatables-header" : "ui-corner-bl ui-corner-br ui-helper-clearfix datatables-footer")} style={this.props.toolBarStyle}>
                    <div id={(isHeader) ? this.props.toolBarRefreshID : ''} className="reactTable-refreshButton" title="Refresh" onClick={this.onToolBarRefresh} hidden={(null == this.props.onToolBarRefresh)}><span className="ui-button-icon-primary ui-icon ui-icon-refresh"></span></div>
                    <div className="dataTables_info" id={this.props.id + '_reactTable_info'}>
                        {(null != this.props.overrideToolBarInfoText) ? this.props.overrideToolBarInfoText(totalRows, 0, totalRows, totalRows, (this.state as ReactTableState).toolBarPageNumber) : <span> Showing 1 to {totalRows} of {overallTotal} {this.props.overrideTableEntriesText} </span>}
                    </div>
                    {(isHeader) ? this.getToolBarListOptions() : null}
                </div>
            </React.Fragment>;
        } else {

            const totalPages = Math.ceil(totalRows / (this.state as ReactTableState).toolBarNumToDisplay);
            const startPos = ((this.state as ReactTableState).toolBarPageNumber - 1) * (this.state as ReactTableState).toolBarNumToDisplay;
            const endPos = ((startPos + (this.state as ReactTableState).toolBarNumToDisplay) > totalRows) ? totalRows : (startPos + (this.state as ReactTableState).toolBarNumToDisplay);

            if (this.props.toolBarDisplayCompact) {
                return <React.Fragment>
                    {getReactButton({id: (isHeader) ? this.props.id + '_headerPageNum_refresh' : this.props.id + '_footerPageNum_refresh', css: 'categoryAllHide', onClick: () => this.onPageNumberRefresh(isHeader), text: 'HIDDEN REFRESH BUTTON'})}
                    <div id={(this.props.id + ((isHeader) ? '_toolBarHeader' : '_toolBarFooter'))} className={'fg-toolbar ui-toolbar ui-widget-header ' + ((isHeader) ? 'ui-corner-tl ui-corner-tr ui-helper-clearfix datatables-header' : 'ui-corner-bl ui-corner-br ui-helper-clearfix datatables-footer')} style={this.props.toolBarCompactStyle}>
                        <div id={(isHeader) ? this.props.toolBarRefreshID : ''} className="reactTable-refreshButton-compact" title="Refresh" onClick={this.onToolBarRefresh} hidden={(null == this.props.onToolBarRefresh)}><span className="ui-button-icon-primary ui-icon ui-icon-refresh "></span></div>
                        <div className="dataTables_paginate fg-buttonset fg-buttonset-multi ui-buttonset-multi paging_input" style={{paddingLeft: (null == this.props.onToolBarRefresh) ? '20px' : ''}}>
                            <button id={this.props.id + '_reactTable_first'} className={'tableToolbarButton fg-button ui-button ui-state-default first ui-corner-tl ui-corner-bl ui-corner-all ui-widget ui-button-icon-only' + (((this.state as ReactTableState).toolBarPageNumber <= 1) ? ' ui-button-disabled ui-state-disabled' : '')} title="First Page: 1" type="button" onClick={this.toolBarPageBeginning} disabled={(this.state as ReactTableState).toolBarPageNumber <= 1} >
                                <span className="ui-button-icon ui-icon ui-icon-seek-first"></span>
                                <span className="ui-button-icon-space"> </span>
                            </button>
                            <button id={this.props.id + '_reactTable_previous'} className={'tableToolbarButton fg-button ui-button ui-state-default previous ui-corner-all ui-widget ui-button-icon-only' + (((this.state as ReactTableState).toolBarPageNumber <= 1) ? ' ui-button-disabled ui-state-disabled' : '')} title="" type="button"  onClick={this.toolBarPageLeft} disabled={(this.state as ReactTableState).toolBarPageNumber <= 1}>
                                <span className="ui-button-icon ui-icon ui-icon-arrowthick-1-w"></span>
                                <span className="ui-button-icon-space"> </span>
                            </button>
                            <input ref={(isHeader) ? this.pageNumberHeaderRef : this.pageNumberFooterRef} className="tableToolbarInput" type="text" id={(isHeader) ? this.props.id + '_headerPageNum' : this.props.id + '_footerPageNum'} name={this.props.id + '_reactTable_pageNum'} value={(this.state as ReactTableState).toolBarPageNumberTyped} aria-label="Page Number Input" onChange={this.changePageNumber} onBlur={this.setPageNumber} onKeyDown={this.onPageNumberKeyPress} onKeyUp={this.onKeyUp} autoComplete="off"></input>
                            <button id={this.props.id + '_reactTable_next'} className={'tableToolbarButton fg-button ui-button ui-state-default next ui-corner-all ui-widget ui-button-icon-only' + (((this.state as ReactTableState).toolBarPageNumber >= totalPages) ? ' ui-button-disabled ui-state-disabled' : '')} title="" type="button" onClick={this.toolBarPageRight} disabled={(this.state as ReactTableState).toolBarPageNumber >= totalPages} >
                                <span className="ui-button-icon ui-icon ui-icon-arrowthick-1-e"></span>
                                <span className="ui-button-icon-space"> </span>
                            </button>
                            <button id={this.props.id + '_reactTable_last'} className={'tableToolbarButton fg-button ui-button ui-state-default last ui-corner-tr ui-corner-br ui-corner-all ui-widget ui-button-icon-only' + (((this.state as ReactTableState).toolBarPageNumber >= totalPages) ? ' ui-button-disabled ui-state-disabled' : '')} title="Last Page: 1" type="button" onClick={this.toolBarPageEnd} disabled={(this.state as ReactTableState).toolBarPageNumber >= totalPages} >
                                <span className="ui-button-icon ui-icon ui-icon-seek-end"></span>
                                <span className="ui-button-icon-space"></span>
                            </button>
                        </div>
                        <div className="reactTable-info" id={this.props.id + "_reactTable_info"}>
                            {(null != this.props.overrideToolBarInfoText) ? this.props.overrideToolBarInfoText(totalRows, startPos, endPos, totalPages, (this.state as ReactTableState).toolBarPageNumber) : <span style={{verticalAlign: 'middle'}} className="ui-button-icon-primary ui-icon ui-icon-comment" title={"Showing " + ((totalRows > 0) ? startPos + 1 : 0) + " to " + ((endPos > totalRows) ? totalRows : endPos) + " of " + totalRows + " " + this.props.overrideTableEntriesText}></span>}
                        </div>
                        {(isHeader) ? this.getToolBarListOptions() : null}
                    </div>
                </React.Fragment>;
            } else {
                return <React.Fragment>
                    {getReactButton({id: (isHeader) ? this.props.id + "_headerPageNum_refresh" : this.props.id + "_footerPageNum_refresh", css: "categoryAllHide", onClick: () => this.onPageNumberRefresh(isHeader), text: "HIDDEN REFRESH BUTTON"})}
                    <div id={(this.props.id + ((isHeader) ? "_toolBarHeader":"_toolBarFooter"))} className={"fg-toolbar ui-toolbar ui-widget-header " + ((isHeader) ? "ui-corner-tl ui-corner-tr ui-helper-clearfix datatables-header" : "ui-corner-bl ui-corner-br ui-helper-clearfix datatables-footer")} style={this.props.toolBarStyle}>
                        <div id={(isHeader) ? this.props.toolBarRefreshID : ''} className="reactTable-refreshButton" title="Refresh" onClick={this.onToolBarRefresh} hidden={(null == this.props.onToolBarRefresh)}><span className="ui-button-icon-primary ui-icon ui-icon-refresh"></span></div>
                        <div id={this.props.id + "_reactTable_length"} className="dataTables_length">
                            {"Show "}
                            <input className="showEntries" id={(this.props.id + ((isHeader) ? "_reactTable_lengthInput1" : "_reactTable_lengthInput2"))} name={this.props.id + "_reactTable_lengthInput"} aria-label="Length Input" value={(this.state as ReactTableState).toolBarNumToDisplayTyped} onChange={this.changeNumberOfEntries} onBlur={this.setNumberToDisplay} onKeyDown={this.onShowEntriesKeyPress} autoComplete="off"/>
                            {" " + this.props.overrideTableEntriesText}
                        </div>
                        <div className="dataTables_paginate fg-buttonset fg-buttonset-multi ui-buttonset-multi paging_input" style={{paddingLeft: (null == this.props.onToolBarRefresh) ? '20px' : ''}}>
                            <button id={this.props.id + '_reactTable_first'} className={'tableToolbarButton fg-button ui-button ui-state-default first ui-corner-tl ui-corner-bl ui-corner-all ui-widget ui-button-icon-only' + (((this.state as ReactTableState).toolBarPageNumber <= 1) ? ' ui-button-disabled ui-state-disabled' : '')} title="First Page: 1" type="button" onClick={this.toolBarPageBeginning} disabled={(this.state as ReactTableState).toolBarPageNumber <= 1} >
                                <span className="ui-button-icon ui-icon ui-icon-seek-first"></span>
                                <span className="ui-button-icon-space"> </span>
                            </button>
                            <button id={this.props.id + '_reactTable_previous'} className={'tableToolbarButton fg-button ui-button ui-state-default previous ui-corner-all ui-widget ui-button-icon-only' + (((this.state as ReactTableState).toolBarPageNumber <= 1) ? ' ui-button-disabled ui-state-disabled' : '')} title="" type="button"  onClick={this.toolBarPageLeft} disabled={(this.state as ReactTableState).toolBarPageNumber <= 1}>
                                <span className="ui-button-icon ui-icon ui-icon-arrowthick-1-w"></span>
                                <span className="ui-button-icon-space"> </span>
                            </button>
                            <input ref={(isHeader) ? this.pageNumberHeaderRef : this.pageNumberFooterRef} className="tableToolbarInput" type="text" id={(isHeader) ? this.props.id + '_headerPageNum' : this.props.id + '_footerPageNum'} name={this.props.id + '_reactTable_pageNum'} value={(this.state as ReactTableState).toolBarPageNumberTyped} aria-label="Page Number Input" onChange={this.changePageNumber} onBlur={this.setPageNumber} onKeyDown={this.onPageNumberKeyPress} onKeyUp={this.onKeyUp} autoComplete="off"></input>
                            <button id={this.props.id + '_reactTable_next'} className={'tableToolbarButton fg-button ui-button ui-state-default next ui-corner-all ui-widget ui-button-icon-only' + (((this.state as ReactTableState).toolBarPageNumber >= totalPages) ? ' ui-button-disabled ui-state-disabled' : '')} title="" type="button" onClick={this.toolBarPageRight} disabled={(this.state as ReactTableState).toolBarPageNumber >= totalPages} >
                                <span className="ui-button-icon ui-icon ui-icon-arrowthick-1-e"></span>
                                <span className="ui-button-icon-space"> </span>
                            </button>
                            <button id={this.props.id + '_reactTable_last'} className={'tableToolbarButton fg-button ui-button ui-state-default last ui-corner-tr ui-corner-br ui-corner-all ui-widget ui-button-icon-only' + (((this.state as ReactTableState).toolBarPageNumber >= totalPages) ? ' ui-button-disabled ui-state-disabled' : '')} title="Last Page: 1" type="button" onClick={this.toolBarPageEnd} disabled={(this.state as ReactTableState).toolBarPageNumber >= totalPages} >
                                <span className="ui-button-icon ui-icon ui-icon-seek-end"></span>
                                <span className="ui-button-icon-space"></span>
                            </button>
                        </div>
                        <div className="dataTables_info" id={this.props.id + '_reactTable_info'}>
                            {(null != this.props.overrideToolBarInfoText) ? this.props.overrideToolBarInfoText(totalRows, startPos, endPos, totalPages, (this.state as ReactTableState).toolBarPageNumber) : <span> Showing {(totalRows > 0) ? startPos + 1 : 0} to {((endPos > totalRows) ? totalRows : endPos)} of {totalRows} {this.props.overrideTableEntriesText} </span>}
                        </div>
                        {(isHeader) ? this.getToolBarListOptions() : null}
                    </div>
                </React.Fragment>;
            }
        }
    }

    onDragStartHandler(event: any, dragRow: any) {
        this.setState(() => ({
            rowIsDragging: true,
            dragRow,
        }));
    }

    onDragStopHandler(event: any) {
        this.setState(() => ({
            rowIsDragging: false,
            dragRow: null,
        }));

        if (null != this.props.onDropEvent) {
            this.props.onDropEvent(event);
        }
    }

    getStoredJSONData(rowIndex: number) {
        let jsonData: any = {};
        jsonData[this.props.dataKey] = (this.state as ReactTableState).rows[rowIndex][this.props.hiddenSelectedKey];

        if (null != this.props.newJSONData) {
            jsonData = this.props.newJSONData((this.state as ReactTableState).rows[rowIndex], rowIndex, jsonData);
        }
        return jsonData;
    }

    indexOfStoredDataJSON(data: any, key: string) {
        for (let i = 0; i < data.length; i++) {
            if (data[i][this.props.dataKey] === key) {
                return i;
            }
        }

        return -1;
    }

    onDragHandler(event: any, dragOverRow: any) {
        if (this.props.enableDragAndDrop) {
            if (null != this.props.onDuringDragEvent && null != (this.state as ReactTableState).dragRow) {
                this.props.onDuringDragEvent(event, (this.state as ReactTableState).dragRow, dragOverRow);
            }
        } else if (this.props.selectRecordsWithRowDrag) {
            const currentIndex = (this.state as ReactTableState).rows.indexOf((this.state as ReactTableState).dragRow);
            const dragIndex = (this.state as ReactTableState).rows.indexOf(dragOverRow);

            const largeIndex = (currentIndex > dragIndex) ? currentIndex : dragIndex;
            const smallIndex = (currentIndex < dragIndex) ? currentIndex : dragIndex;

            const ctrlKeyPressed = event.ctrlKey;

            for (let i = 0; i < (this.state as ReactTableState).rows.length; i++) {
                const row: any = (this.state as ReactTableState).rows[i];
                const isSelected = (i >= smallIndex && i <= largeIndex);

                if (this.storedDataAsJSONArray) {

                    const storageIndex = this.indexOfStoredDataJSON((this.state as ReactTableState).storedData, row[this.props.hiddenSelectedKey]);

                    if (null != this.props.dataKey) {
                        if (ctrlKeyPressed && storageIndex > -1) {
                            continue;
                        } else {
                            if (isSelected) {
                                if (storageIndex < 0) {
                                    (this.state as ReactTableState).storedData.push(this.getStoredJSONData(i));
                                }
                            } else {
                                if (storageIndex >= 0) {
                                    (this.state as ReactTableState).storedData.splice(storageIndex, 1);
                                }
                            }
                        }
                    }
                } else if (this.useRowDataStorage) {
                    if (null != this.props.dataKey) {
                        if (ctrlKeyPressed && (this.state as ReactTableState).storedData[this.props.dataKey]) {
                            continue;
                        } else {
                            (this.state as ReactTableState).storedData[this.props.dataKey] = isSelected;
                        }
                    }
                } else {
                    if (null != this.props.isSelectedKey) {
                        if (ctrlKeyPressed && row[this.props.isSelectedKey]) {
                            continue;
                        } else {
                            row[this.props.isSelectedKey] = isSelected;
                        }
                    }
                }
            }

            this.setState(() => ({
                rows: (this.state as ReactTableState).rows,
            }));
        }
    }

    onDuringDragHeader(event: any, dragOverHeader: any, headerCellRef: RefObject<any>) {
        if (null != this.props.onDuringDragHeader && null != (this.state as ReactTableState).dragHeader) {
            this.props.onDuringDragHeader(event, (this.state as ReactTableState).dragHeader, dragOverHeader, headerCellRef);
        }
    }

    onDragHeaderStart(event: any, dragHeader: any) {
        this.setState(() => ({
            headerIsDragging: true,
            dragHeader,
        }));
    }

    onDragHeaderStop(event: any, dragHeader: any) {
        if (null != this.props.onDropHeaderEvent) {
            this.props.onDropHeaderEvent(event, (this.state as ReactTableState).dragHeader, dragHeader);
        }

        this.setState(() => ({
            headerIsDragging: false,
            dragHeader: null,
        }));
    }

    onDelete(row: any) {
        // Get the row and remove it from the rows array
        const rowIndex = this.indexOfFilteredRow(row);
        if (rowIndex > -1) {
            if (null != this.props.onDelete) {
                const updatedPageNumber = this.props.onDelete(rowIndex);

                // Move back to the previous page if all records on this page are deleted (unless of course they are on page 1)
                if (updatedPageNumber > 0) {
                    this.setState({
                        toolBarPageNumber: updatedPageNumber,
                        toolBarPageNumberTyped: updatedPageNumber,
                        highlightSelectedRow: ((this.useHighlightSelectedRow) ? 0 : -1)
                    }, () => {
                        this.updateState(false);
                    });
                }
            }
        }
    }

    indexOfLockedRow(rowIndex: number) {
        let index = -1;
        if (this.props.lockedRows) {
            for (let i = 0; i < this.props.lockedRows.length; i++) {
                if (this.props.lockedRows[i] == rowIndex) {
                    index = i;
                }
            }
        }
        return index;
    }

    onRowClick(rowObj: any, shiftKey: boolean, ctrlKey: boolean, applySelection: boolean) {
        if (this.props.selectRecordWithRowClick) {
            this.props.onSelectCellClick(rowObj, shiftKey, ctrlKey, applySelection, this.lastSelectedRowIndex);
        }
        this.lastSelectedRowIndex = this.indexOfFilteredRow(rowObj);
    }

    buildRow(row: any, rowIndex: number, overallIndex: number, isDisabled: boolean, lastIndex: number) {

        let hasFocus = false;
        let highlightRow = false;
        if ((rowIndex == (this.state as ReactTableState).highlightSelectedRow)) {
            highlightRow = true;
            hasFocus = true;
        } else if (this.storedDataAsJSONArray) {
            const storageIndex = this.indexOfStoredDataJSON((this.state as ReactTableState).storedData, row[this.props.hiddenSelectedKey]);
            highlightRow = ((this.props.selectRecordWithRowClick || this.props.selectRecordsWithRowDrag) && ((null != row[this.props.hiddenSelectedKey]) ? (storageIndex > -1) : false));
        } else if (this.useRowDataStorage) {
            highlightRow = ((this.props.selectRecordWithRowClick || this.props.selectRecordsWithRowDrag) && ((null != row[this.props.hiddenSelectedKey]) ? row[this.props.hiddenSelectedKey] == (this.state as ReactTableState).storedData[this.props.dataKey] : false));
        } else {
            highlightRow = ((this.props.selectRecordWithRowClick || this.props.selectRecordsWithRowDrag) && ((null != row[this.props.isSelectedKey]) ? row[this.props.isSelectedKey] : false));
        }

        let setDisabled = ((isDisabled) ? true : ((this.indexOfLockedRow(rowIndex) >= 0) ? true : false));
        if (!setDisabled && null != this.props.disableRow) {
            setDisabled = this.props.disableRow(row, rowIndex);
        }

        const isDraggingRow = this.props.enableDragAndDrop && ((this.state as ReactTableState).dragRow == row) && (this.state as ReactTableState).rowIsDragging;

        let rowClass = (rowIndex % 2) ? 'odd' : 'even';
        if (isDraggingRow) {
            rowClass = rowClass + ' react-drag';
        }

        if (null != row.css && 'undefined' != row.css) {
            rowClass = row.css + ' ' + rowClass;
        } else if (null != this.props.rowsCSS) {
            rowClass = this.props.rowsCSS(row, rowIndex, isDraggingRow);
        }

        if ((this.state as ReactTableState).rowIsDragging) {
            rowClass = rowClass.replace(new RegExp('\\b' + 'datatableRow' + '\\b'), '');
            rowClass = rowClass.replace(new RegExp('\\b' + 'datatableRow ' + '\\b'), '');
        }

        let rowStyle = {};
        if (null != row.style && 'undefined' != row.style) {
            rowStyle = row.style;
        } else if (null != this.props.rowsStyle) {
            rowStyle = this.props.rowsStyle(row, rowIndex);
        }

        let rowID = '';
        if (null != this.props.overrideRowID) {
            rowID = this.props.overrideRowID(row, rowIndex, overallIndex);
        } else {
            rowID = (null != row.id && 'undefined' != row.id) ? row.id : (overallIndex + '_' + this.props.id);
        }
        const rowName = (null != this.props.overrideRowName) ? this.props.overrideRowName(row, rowIndex, overallIndex) : '';

        return <ReactRow
            row={row}
            rowClass={rowClass}
            rowStyle={rowStyle}
            id={rowID}
            name={rowName}
            headers={this.props.headers}
            addSelectColumn={this.props.addSelectColumn}
            selectColumnIndex={this.props.selectColumnIndex}
            deleteButtonTabIndex={this.props.deleteButtonTabIndex}
            onRowClick={this.onRowClick}
            onSelectCellClick={this.props.onSelectCellClick}
            rowIndex={rowIndex}
            overallIndex={overallIndex}
            disabled={setDisabled}
            selectColumns={this.props.selectColumns}
            doHighlightRow={highlightRow}
            rowHasFocus={hasFocus}
            enableDragAndDrop={this.props.enableDragAndDrop}
            sortColumnIndex={this.props.sortColumnIndex}
            onDragStart={this.onDragStartHandler}
            onDragStop={this.onDragStopHandler}
            onDuringDrag={this.onDragHandler}
            addDeleteColumn={this.props.addDeleteColumn}
            deleteButtonStyle={this.props.deleteButtonStyle}
            deleteColumnIndex={this.props.deleteColumnIndex}
            onDelete={this.onDelete}
            onRowDoubleClick={this.props.onRowDoubleClick}
            rowReference={((highlightRow) ? this.highlightRowRef : null)}
            hightlightSelectedRowCSS={this.props.hightlightSelectedRowCSS}
            rowHasFocusCSS={this.props.rowHasFocusCSS}
            selectRecordWithRowClick={this.props.selectRecordWithRowClick}
            selectRecordsWithRowDrag={this.props.selectRecordsWithRowDrag}
            isSelectedKey={this.props.isSelectedKey}
            useRowDataStorage={this.useRowDataStorage}
            storedData={(this.state as ReactTableState).storedData}
            dataKey={this.props.dataKey}
            hiddenSelectedKey={this.props.hiddenSelectedKey}
            hiddenSelectedKeyDelimiter={this.props.hiddenSelectedKeyDelimiter}
            parentTableRef={this.tableRef}
            disableDelete={this.props.disableDelete}
            storedDataAsJSONArray={this.storedDataAsJSONArray}
            newJSONData={this.props.newJSONData}
            deleteButtonID={this.props.deleteButtonID}
            deleteButtonName={this.props.deleteButtonName}
            selectCheckBoxID={this.props.selectCheckBoxID}
            selectCheckBoxName={this.props.selectCheckBoxName}
            lastIndex={lastIndex}
            searchValue={this.props.searchValue}
        />;
    }

    buildRows(rows: any[], isDisabled: boolean) {
        let startPos = 0;
        let endPos = rows.length;

        if (endPos == 0) {
            let columnCount = this.props.headers.length;
            if (this.props.addSelectColumn) {
                columnCount = columnCount + 1; // Add one for the select column
            }
            if (this.props.addDeleteColumn) {
                columnCount = columnCount + 1; // Add one for the delete column
            }
            if (this.props.enableDragAndDrop) {
                columnCount = columnCount + 1; // Add one for the sort column
            }

            return <tr className={'odd'}><td colSpan={columnCount} className={this.props.emptyRowCSS}>{(this.props.noRecordsSelectedText != '') ? this.props.noRecordsSelectedText : 'No records selected'}</td></tr>;
        } else {
            if (this.getIsUsingPaging() || this.props.isSearchAsYouType) {
                startPos = ((this.state as ReactTableState).toolBarPageNumber - 1) * (this.state as ReactTableState).toolBarNumToDisplay;
                endPos = startPos + (this.state as ReactTableState).toolBarNumToDisplay;
            }

            return rows.slice(startPos, endPos).map((row, rowIndex) => this.buildRow(row, rowIndex, (startPos + rowIndex), isDisabled, (this.state as ReactTableState).filteredRows.length));
        }
    }

    getIsUsingPaging() {
        return !this.props.toolBarDisablePaging && (this.props.toolBarDisplayHeader || this.props.toolBarDisplayFooter);
    }

    buildTable() {

        let css = '';
        if (null != this.props.divSAYTWindowCSS) {
            css = this.props.divSAYTWindowCSS;
        } else {
            css = (this.props.isSearchAsYouType) ? 'flex-container flex-column flex-grow reactSAYTWindow' : '';
            if (this.props.toolBarDisplayHeader) {
                css = css + ' react-rounded-top';
            }
        }

        let shellCSS = '';
        if (this.props.divTableShellCSS) {
            shellCSS = this.props.divTableShellCSS;
        } else if (this.props.isSearchAsYouType) {
            shellCSS = 'reactTableShell';
        }

        return <div id={this.props.id} className={shellCSS} style={{zIndex: (this.state as ReactTableState).zIndex}}>
            <div id={this.props.id + '_shellDiv'} ref={this.saytTableRef} className={css}>
                {(null != this.props.addCustomFilterOptions) ? <div id={this.props.id + '_customFilter'} className={this.props.customFilterCSS}>{this.props.addCustomFilterOptions((this.state as ReactTableState).storedData, (this.state as ReactTableState).filteredRows)}</div> : null}
                <table id={this.props.id + '_shellTable'} className={'fillSpace'}>
                    {this.buildTotalRowsSelected()}
                    {(this.props.toolBarDisplayHeader) ? this.buildToolBar(true) : getReactButton({id: this.props.toolBarRefreshID, css: 'categoryAllHide', onClick: this.onToolBarRefresh, text: 'HIDDEN TOOLBAR REFRESH BUTTON'})}
                    <div id={this.props.id + '_tableDiv'} ref={this.tableRef} onScroll={this.onScroll} className={this.props.css} style={this.props.style} >
                        <table id={this.props.id + '_tableElement'} className="object-selection-table " >
                            <ReactHeader
                                id={this.props.id}
                                css={this.props.headersCSS}
                                headerRef={this.headerRef}
                                headers={this.props.headers}
                                addSelectColumn={this.props.addSelectColumn}
                                selectColumnIndex={this.props.selectColumnIndex}
                                enableDragAndDrop={this.props.enableDragAndDrop}
                                sortColumnIndex={this.props.sortColumnIndex}
                                selectHeaderClick={this.props.selectHeaderClick}
                                sortTable={this.sortTable}
                                addDeleteColumn={this.props.addDeleteColumn}
                                deleteColumnIndex={this.props.deleteColumnIndex}
                                overrideSortID={this.props.overrideSortID}
                                overrideSortName={this.props.overrideSortName}
                                onDuringDragHeader={this.onDuringDragHeader}
                                onDragHeaderStart={this.onDragHeaderStart}
                                onDragHeaderStop={this.onDragHeaderStop}
                                deleteColumnHeader={this.props.deleteColumnHeader}
                            />
                            <tbody className="ui-sortable">
                            {this.buildRows((this.state as ReactTableState).filteredRows, this.props.disabled)}
                            </tbody>
                        </table>
                    </div>
                    {(this.props.toolBarDisplayFooter) ? this.buildToolBar(false) : ''}
                </table>
            </div>
        </div>;
    }

    buildTableLabel() {
        return <label>
            {this.props.tableLabel}
        </label>;
    }

    buildDataTable() {
        return <table className="fillSpace">
            {(this.props.tableLabel) ? this.buildTableLabel() : null}
            {((this.state as ReactTableState).showTable) ? this.buildTable() : null}
        </table>;
    }

    render() {
        return <div id={this.props.id + '_containerShell'} className={(null != this.props.divTableContainerShellCSS) ? this.props.divTableContainerShellCSS : ''}>
            {this.buildDataTable()}
        </div>;
    }
}

